import { LanguagesEnum } from '@/api/enums';

const hardcodedTranslations = {
  quiz: {
    answer: {
      correct: {
        [LanguagesEnum.EN as string]: 'Correct. The correct answer is:',
        [LanguagesEnum.DK as string]: 'Korrekt. Det rigtige svar er:',
        [LanguagesEnum.SE as string]: 'Rätt. Det rätta svaret är:',
        [LanguagesEnum.NO as string]: 'Riktig. Det riktige svaret er:',
        [LanguagesEnum.DE as string]: 'Richtig. Die richtige Antwort ist:',
        [LanguagesEnum.KL as string]: 'Eqqorpoq. Akissut eqqortoq tassaavoq:',
        [LanguagesEnum.AR as string]: 'صحيح. الإجابة الصحيحة هي:',
        [LanguagesEnum.CZ as string]: 'Správně. Správná odpověď je:',
        [LanguagesEnum.ES as string]: 'Correcto. La respuesta correcta es:',
        [LanguagesEnum.FI as string]: 'Oikein. Oikea vastaus on:',
        [LanguagesEnum.FR as string]: 'Correct. La bonne réponse est :',
        [LanguagesEnum.IT as string]: 'Corretto. La risposta corretta è:',
        [LanguagesEnum.LT as string]: 'Teisingai. Teisingas atsakymas yra:',
        [LanguagesEnum.LV as string]: 'Pareizi. Pareizā atbilde ir:',
        [LanguagesEnum.NL as string]: 'Correct. Het juiste antwoord is:',
        [LanguagesEnum.PG as string]: 'Correto. A resposta correta é:',
        [LanguagesEnum.PL as string]: 'Poprawna. Poprawna odpowiedź to:',
        [LanguagesEnum.TR as string]: 'Doğru. Doğru cevap:',
        [LanguagesEnum.VI as string]: 'Đúng. Đáp án đúng là:',
        [LanguagesEnum.ZH as string]: '正确. 正确答案是：',
        [LanguagesEnum.RO as string]: 'Corect. Răspunsul corect este:',
        [LanguagesEnum.UA as string]: 'Правильно. Правильна відповідь:',
        [LanguagesEnum.BG as string]: 'Правилно. Правилният отговор е:',
        [LanguagesEnum.EL as string]: 'Σωστό. Η σωστή απάντηση είναι:',
        [LanguagesEnum.ET as string]: 'Õige. Õige vastus on:',
        [LanguagesEnum.HE as string]: 'נכון. התשובה הנכונה היא:',
        [LanguagesEnum.HU as string]: 'Helyes. A helyes válasz:',
        [LanguagesEnum.ID as string]: 'Benar. Jawaban yang benar adalah:',
        [LanguagesEnum.JA as string]: '正解です。正しい答えは：',
        [LanguagesEnum.KO as string]: '정답입니다. 정답은:',
        [LanguagesEnum.RU as string]: 'Правильно. Правильный ответ:',
        [LanguagesEnum.SK as string]: 'Správne. Správna odpoveď je:',
        [LanguagesEnum.SL as string]: 'Pravilno. Pravilen odgovor je:',
        [LanguagesEnum.TH as string]: 'ถูกต้อง คำตอบที่ถูกต้องคือ:',
        [LanguagesEnum.HR as string]: 'Točno. Točan odgovor je:',
        [LanguagesEnum.SR as string]: 'Tačno. Tačan odgovor je:',
        [LanguagesEnum.MS as string]: 'Betul. Jawapan yang betul ialah:',
        [LanguagesEnum.HI as string]: 'सही। सही उत्तर है:',
        [LanguagesEnum.SQ as string]: 'Saktë. Përgjigjja e saktë është:',
        [LanguagesEnum.BA as string]: 'Tačno. Tačan odgovor je:',
        [LanguagesEnum.MK as string]: 'Точно. Точниот одговор е:',
        [LanguagesEnum.IS as string]: 'Rétt. Rétt svar er:',
        [LanguagesEnum.LB as string]: 'Richteg. Déi richteg Äntwert ass:',
        [LanguagesEnum.BR as string]: 'Correto. A resposta correta é:',
        [LanguagesEnum.UR as string]: 'درست۔ صحیح جواب ہے:',
        [LanguagesEnum.TL as string]: 'Tama. Ang tamang sagot ay:',
        [LanguagesEnum.TA as string]: 'சரி. சரியான பதில்:',
        [LanguagesEnum.BN as string]: 'সঠিক। সঠিক উত্তর হলো:',
        [LanguagesEnum.FA as string]: 'درست است. پاسخ صحیح:',
      },
      incorrect: {
        [LanguagesEnum.EN as string]: 'Incorrect. The correct answer is:',
        [LanguagesEnum.DK as string]: 'Forkert. Det rigtige svar er:',
        [LanguagesEnum.SE as string]: 'Fel. Det rätta svaret är:',
        [LanguagesEnum.NO as string]: 'Feil. Det riktige svaret er:',
        [LanguagesEnum.DE as string]: 'Falsch. Die richtige Antwort ist:',
        [LanguagesEnum.KL as string]:
          'Eqqunngilaq. Akissut eqqortoq tassaavoq:',
        [LanguagesEnum.AR as string]: 'خطأ. الإجابة الصحيحة هي:',
        [LanguagesEnum.CZ as string]: 'Špatně. Správná odpověď je:',
        [LanguagesEnum.ES as string]: 'Incorrecto. La respuesta correcta es:',
        [LanguagesEnum.FI as string]: 'Väärin. Oikea vastaus on:',
        [LanguagesEnum.FR as string]: 'Incorrect. La bonne réponse est :',
        [LanguagesEnum.IT as string]: 'Errato. La risposta corretta è:',
        [LanguagesEnum.LT as string]: 'Neteisingai. Teisingas atsakymas yra:',
        [LanguagesEnum.LV as string]: 'Nepareizi. Pareizā atbilde ir:',
        [LanguagesEnum.NL as string]: 'Onjuist. Het juiste antwoord is:',
        [LanguagesEnum.PG as string]: 'Incorreto. A resposta correta é:',
        [LanguagesEnum.PL as string]: 'Niepoprawna. Poprawna odpowiedź to:',
        [LanguagesEnum.TR as string]: 'Yanlış. Doğru cevap:',
        [LanguagesEnum.VI as string]: 'Sai. Đáp án đúng là:',
        [LanguagesEnum.ZH as string]: '错误. 正确答案是：',
        [LanguagesEnum.RO as string]: 'Greșit. Răspunsul corect este:',
        [LanguagesEnum.UA as string]: 'Неправильно. Правильна відповідь:',
        [LanguagesEnum.BG as string]: 'Грешно. Правилният отговор е:',
        [LanguagesEnum.EL as string]: 'Λάθος. Η σωστή απάντηση είναι:',
        [LanguagesEnum.ET as string]: 'Vale. Õige vastus on:',
        [LanguagesEnum.HE as string]: 'לא נכון. התשובה הנכונה היא:',
        [LanguagesEnum.HU as string]: 'Helytelen. A helyes válasz:',
        [LanguagesEnum.ID as string]: 'Salah. Jawaban yang benar adalah:',
        [LanguagesEnum.JA as string]: '不正解です。正しい答えは：',
        [LanguagesEnum.KO as string]: '오답입니다. 정답은:',
        [LanguagesEnum.RU as string]: 'Неправильно. Правильный ответ:',
        [LanguagesEnum.SK as string]: 'Nesprávne. Správna odpoveď je:',
        [LanguagesEnum.SL as string]: 'Napačno. Pravilen odgovor je:',
        [LanguagesEnum.TH as string]: 'ผิด คำตอบที่ถูกต้องคือ:',
        [LanguagesEnum.HR as string]: 'Netočno. Točan odgovor je:',
        [LanguagesEnum.SR as string]: 'Netačno. Tačan odgovor je:',
        [LanguagesEnum.MS as string]: 'Salah. Jawapan yang betul ialah:',
        [LanguagesEnum.HI as string]: 'गलत। सही उत्तर है:',
        [LanguagesEnum.SQ as string]: 'Gabim. Përgjigjja e saktë është:',
        [LanguagesEnum.BA as string]: 'Netačno. Tačan odgovor je:',
        [LanguagesEnum.MK as string]: 'Неточно. Точниот одговор е:',
        [LanguagesEnum.IS as string]: 'Rangt. Rétt svar er:',
        [LanguagesEnum.LB as string]: 'Falsch. Déi richteg Äntwert ass:',
        [LanguagesEnum.BR as string]: 'Incorreto. A resposta correta é:',
        [LanguagesEnum.UR as string]: 'غلط۔ صحیح جواب ہے:',
        [LanguagesEnum.TL as string]: 'Mali. Ang tamang sagot ay:',
        [LanguagesEnum.TA as string]: 'தவறு. சரியான பதில்:',
        [LanguagesEnum.BN as string]: 'ভুল। সঠিক উত্তর হলো:',
        [LanguagesEnum.FA as string]: 'نادرست است. پاسخ صحیح:',
      },
      selectAllOptionsThatApply: {
        [LanguagesEnum.EN as string]: 'Please select all options that apply',
        [LanguagesEnum.DK as string]: 'Vælg alle korrekte svarmuligheder',
        [LanguagesEnum.SE as string]: 'Välj alla korrekta svarsalternativ',
        [LanguagesEnum.NO as string]: 'Velg alle riktige svaralternativer',
        [LanguagesEnum.DE as string]:
          'Bitte wählen Sie alle richtigen Antworten aus',
        [LanguagesEnum.KL as string]: 'Eqqortut tamarmik toqqakkit',
        [LanguagesEnum.AR as string]: 'يرجى اختيار جميع الإجابات الصحيحة',
        [LanguagesEnum.CZ as string]: 'Vyberte všechny správné odpovědi',
        [LanguagesEnum.ES as string]:
          'Selecciona todas las respuestas correctas',
        [LanguagesEnum.FI as string]: 'Valitse kaikki oikeat vaihtoehdot',
        [LanguagesEnum.FR as string]:
          'Veuillez sélectionner toutes les réponses correctes',
        [LanguagesEnum.IT as string]: 'Seleziona tutte le risposte corrette',
        [LanguagesEnum.LT as string]: 'Pasirinkite visus teisingus atsakymus',
        [LanguagesEnum.LV as string]:
          'Atlasiet visus pareizos atbilžu variantus',
        [LanguagesEnum.NL as string]: 'Selecteer alle juiste antwoorden',
        [LanguagesEnum.PG as string]: 'Selecione todas as respostas corretas',
        [LanguagesEnum.PL as string]: 'Wybierz wszystkie poprawne odpowiedzi',
        [LanguagesEnum.TR as string]: 'Doğru olan tüm seçenekleri seçin',
        [LanguagesEnum.VI as string]: 'Vui lòng chọn tất cả các đáp án đúng',
        [LanguagesEnum.ZH as string]: '请选择所有正确的选项',
        [LanguagesEnum.RO as string]: 'Selectați toate răspunsurile corecte',
        [LanguagesEnum.UA as string]:
          'Виберіть усі правильні варіанти відповіді',
        [LanguagesEnum.BG as string]: 'Моля, изберете всички приложими опции',
        [LanguagesEnum.EL as string]:
          'Παρακαλώ επιλέξτε όλες τις εφαρμοστές επιλογές',
        [LanguagesEnum.ET as string]: 'Palun valige kõik sobivad vastused',
        [LanguagesEnum.HE as string]: 'אנא בחר את כל האפשרויות החלות',
        [LanguagesEnum.HU as string]:
          'Kérjük, válassza ki az összes alkalmazandó lehetőséget',
        [LanguagesEnum.ID as string]: 'Silakan pilih semua opsi yang berlaku',
        [LanguagesEnum.JA as string]:
          '該当するすべてのオプションを選択してください',
        [LanguagesEnum.KO as string]: '해당하는 모든 옵션을 선택해 주세요',
        [LanguagesEnum.RU as string]:
          'Пожалуйста, выберите все подходящие варианты',
        [LanguagesEnum.SK as string]: 'Vyberte všetky platné možnosti',
        [LanguagesEnum.SL as string]: 'Prosimo, izberite vse veljavne možnosti',
        [LanguagesEnum.TH as string]: 'กรุณาเลือกตัวเลือกทั้งหมดที่ใช้ได้',
        [LanguagesEnum.HR as string]: 'Molimo odaberite sve primjenjive opcije',
        [LanguagesEnum.SR as string]: 'Molimo odaberite sve primenljive opcije',
        [LanguagesEnum.MS as string]: 'Sila pilih semua pilihan yang berkenaan',
        [LanguagesEnum.HI as string]: 'कृपया सभी लागू विकल्प चुनें',
        [LanguagesEnum.SQ as string]: 'Zgjidhni të gjitha opsionet që vlejnë',
        [LanguagesEnum.BA as string]: 'Molimo odaberite sve primjenjive opcije',
        [LanguagesEnum.MK as string]: 'Изберете ги сите соодветни опции',
        [LanguagesEnum.IS as string]: 'Veldu alla viðeigandi valkosti',
        [LanguagesEnum.LB as string]: 'Wielt all passend Optiounen',
        [LanguagesEnum.BR as string]: 'Selecione todas as opções aplicáveis',
        [LanguagesEnum.UR as string]: 'براہ کرم تمام درست اختیارات منتخب کریں',
        [LanguagesEnum.TL as string]: 'Piliin ang lahat ng naaangkop na opsyon',
        [LanguagesEnum.TA as string]:
          'பொருந்தும் அனைத்து தேர்வுகளையும் தேர்ந்தெடுக்கவும்',
        [LanguagesEnum.BN as string]: 'প্রযোজ্য সব অপশন নির্বাচন করুন',
        [LanguagesEnum.FA as string]:
          'لطفاً همه گزینه‌های مربوط را انتخاب کنید',
      },
    },
    youNeedToSelectMultipleAnswers: {
      [LanguagesEnum.EN as string]:
        'You need to select multiple answers to this question',
      [LanguagesEnum.DK as string]:
        'Du skal vælge flere svar til dette spørgsmål',
      [LanguagesEnum.SE as string]:
        'Du behöver välja flera svar på den här frågan',
      [LanguagesEnum.NO as string]:
        'Du må velge flere svar på dette spørsmålet',
      [LanguagesEnum.DE as string]:
        'Bitte wählen Sie mehrere Antworten für diese Frage',
      [LanguagesEnum.KL as string]:
        'Apeqqut una akiniarlugu akissutit arlallit toqqartariaqarpat',
      [LanguagesEnum.AR as string]: 'يجب عليك اختيار عدة إجابات لهذا السؤال',
      [LanguagesEnum.CZ as string]: 'U této otázky musíte vybrat více odpovědí',
      [LanguagesEnum.ES as string]:
        'Debes seleccionar varias respuestas para esta pregunta',
      [LanguagesEnum.FI as string]:
        'Sinun täytyy valita useampi vastaus tähän kysymykseen',
      [LanguagesEnum.FR as string]:
        'Veuillez sélectionner plusieurs réponses pour cette question',
      [LanguagesEnum.IT as string]:
        'Devi selezionare più risposte per questa domanda',
      [LanguagesEnum.LT as string]:
        'Šiam klausimui turite pasirinkti kelis atsakymus',
      [LanguagesEnum.LV as string]:
        'Šajā jautājumā ir jāizvēlas vairākas atbildes',
      [LanguagesEnum.NL as string]:
        'Je moet meerdere antwoorden selecteren voor deze vraag',
      [LanguagesEnum.PG as string]:
        'Você precisa selecionar várias respostas para esta pergunta',
      [LanguagesEnum.PL as string]:
        'Musisz wybrać więcej niż jedną odpowiedź na to pytanie',
      [LanguagesEnum.TR as string]:
        'Bu soru için birden fazla cevap seçmeniz gerekiyor',
      [LanguagesEnum.VI as string]:
        'Bạn cần chọn nhiều câu trả lời cho câu hỏi này',
      [LanguagesEnum.ZH as string]: '此题需要选择多个答案',
      [LanguagesEnum.RO as string]:
        'Trebuie să selectați mai multe răspunsuri la această întrebare',
      [LanguagesEnum.BG as string]:
        'Трябва да изберете повече от един отговор на този въпрос.',
      [LanguagesEnum.EL as string]:
        'Πρέπει να επιλέξετε περισσότερες από μία απαντήσεις σε αυτήν την ερώτηση.',
      [LanguagesEnum.HE as string]: 'יש לבחור יותר מתשובה אחת לשאלה זו.',
      [LanguagesEnum.HU as string]:
        'Ehhez a kérdéshez több választ kell kiválasztania.',
      [LanguagesEnum.ID as string]:
        'Anda perlu memilih lebih dari satu jawaban untuk pertanyaan ini.',
      [LanguagesEnum.JA as string]:
        'この質問には複数の回答を選択する必要があります。',
      [LanguagesEnum.KO as string]:
        '이 질문에는 여러 개의 답변을 선택해야 합니다.',
      [LanguagesEnum.RU as string]:
        'Вам нужно выбрать несколько ответов на этот вопрос.',
      [LanguagesEnum.SK as string]:
        'Na túto otázku musíte vybrať viac odpovedí.',
      [LanguagesEnum.SL as string]:
        'Pri tem vprašanju morate izbrati več odgovorov.',
      [LanguagesEnum.TH as string]:
        'คุณต้องเลือกคำตอบมากกว่าหนึ่งข้อสำหรับคำถามนี้',
      [LanguagesEnum.UA as string]:
        'Вам потрібно вибрати кілька відповідей на це запитання.',
      [LanguagesEnum.ET as string]: 'Peate valima mitu vastust',
      [LanguagesEnum.HR as string]:
        'Morate odabrati više odgovora na ovo pitanje',
      [LanguagesEnum.SR as string]:
        'Morate odabrati više odgovora na ovo pitanje',
      [LanguagesEnum.MS as string]:
        'Anda perlu memilih beberapa jawapan untuk soalan ini',
      [LanguagesEnum.HI as string]:
        'आपको इस प्रश्न के लिए एक से अधिक उत्तर चुनने होंगे',
      [LanguagesEnum.SQ as string]: 'Duhet të zgjidhni disa përgjigje',
      [LanguagesEnum.BA as string]:
        'Morate odabrati više odgovora na ovo pitanje',
      [LanguagesEnum.MK as string]: 'Треба да изберете повеќе одговори',
      [LanguagesEnum.IS as string]: 'Þú þarft að velja fleiri en eitt svar',
      [LanguagesEnum.LB as string]: 'Du muss méi wéi eng Äntwert wielen',
      [LanguagesEnum.BR as string]:
        'É necessário selecionar múltiplas respostas',
      [LanguagesEnum.UR as string]: 'آپ کو متعدد جوابات منتخب کرنے ہوں گے',
      [LanguagesEnum.TL as string]:
        'Kailangan mong pumili ng higit sa isang sagot',
      [LanguagesEnum.TA as string]:
        'ஒன்றுக்கு மேற்பட்ட பதில்களைத் தேர்ந்தெடுக்க வேண்டும்',
      [LanguagesEnum.BN as string]: 'একাধিক উত্তর নির্বাচন করতে হবে',
      [LanguagesEnum.FA as string]: 'باید بیش از یک پاسخ انتخاب کنید',
    },
    currentOutOfTotal: {
      [LanguagesEnum.EN as string]: (x: number, y: number) =>
        `Question ${x} out of ${y}`,
      [LanguagesEnum.DK as string]: (x: number, y: number) =>
        `Spørgsmål ${x} ud af ${y}`,
      [LanguagesEnum.SE as string]: (x: number, y: number) =>
        `Fråga ${x} av ${y}`,
      [LanguagesEnum.NO as string]: (x: number, y: number) =>
        `Spørsmål ${x} av ${y}`,
      [LanguagesEnum.DE as string]: (x: number, y: number) =>
        `Frage ${x} von ${y}`,
      [LanguagesEnum.KL as string]: (x: number, y: number) =>
        `Apeqqut ${x} tamarmik ${y}`,
      [LanguagesEnum.AR as string]: (x: number, y: number) =>
        `السؤال ${x} من ${y}`,
      [LanguagesEnum.CZ as string]: (x: number, y: number) =>
        `Otázka ${x} z ${y}`,
      [LanguagesEnum.ES as string]: (x: number, y: number) =>
        `Pregunta ${x} de ${y}`,
      [LanguagesEnum.FI as string]: (x: number, y: number) =>
        `Kysymys ${x} / ${y}`,
      [LanguagesEnum.FR as string]: (x: number, y: number) =>
        `Question ${x} sur ${y}`,
      [LanguagesEnum.IT as string]: (x: number, y: number) =>
        `Domanda ${x} di ${y}`,
      [LanguagesEnum.LT as string]: (x: number, y: number) =>
        `Klausimas ${x} iš ${y}`,
      [LanguagesEnum.LV as string]: (x: number, y: number) =>
        `Jautājums ${x} no ${y}`,
      [LanguagesEnum.NL as string]: (x: number, y: number) =>
        `Vraag ${x} van ${y}`,
      [LanguagesEnum.PG as string]: (x: number, y: number) =>
        `Pergunta ${x} de ${y}`,
      [LanguagesEnum.PL as string]: (x: number, y: number) =>
        `Pytanie ${x} z ${y}`,
      [LanguagesEnum.TR as string]: (x: number, y: number) =>
        `Soru ${x} / ${y}`,
      [LanguagesEnum.VI as string]: (x: number, y: number) =>
        `Câu hỏi ${x} trên ${y}`,
      [LanguagesEnum.ZH as string]: (x: number, y: number) =>
        `第${x}题，共${y}题`,
      [LanguagesEnum.RO as string]: (x: number, y: number) =>
        `Întrebarea ${x} din ${y}`,
      [LanguagesEnum.UA as string]: (x: number, y: number) =>
        `Питання ${x} із ${y}`,
      [LanguagesEnum.BG as string]: (x: number, y: number) =>
        `Въпрос ${x} от ${y}`,
      [LanguagesEnum.EL as string]: (x: number, y: number) =>
        `Ερώτηση ${x} από ${y}`,
      [LanguagesEnum.ET as string]: (x: number, y: number) =>
        `Küsimus ${x} / ${y}`,
      [LanguagesEnum.HE as string]: (x: number, y: number) =>
        `שאלה ${x} מתוך ${y}`,
      [LanguagesEnum.HU as string]: (x: number, y: number) =>
        `Kérdés ${x} / ${y}`,
      [LanguagesEnum.ID as string]: (x: number, y: number) =>
        `Pertanyaan ${x} dari ${y}`,
      [LanguagesEnum.JA as string]: (x: number, y: number) =>
        `質問 ${x} / ${y}`,
      [LanguagesEnum.KO as string]: (x: number, y: number) =>
        `문제 ${x} / ${y}`,
      [LanguagesEnum.RU as string]: (x: number, y: number) =>
        `Вопрос ${x} из ${y}`,
      [LanguagesEnum.SK as string]: (x: number, y: number) =>
        `Otázka ${x} z ${y}`,
      [LanguagesEnum.SL as string]: (x: number, y: number) =>
        `Vprašanje ${x} od ${y}`,
      [LanguagesEnum.TH as string]: (x: number, y: number) =>
        `คำถาม ${x} จาก ${y}`,
      [LanguagesEnum.HR as string]: (x: number, y: number) =>
        `Pitanje ${x} od ${y}`,
      [LanguagesEnum.SR as string]: (x: number, y: number) =>
        `Pitanje ${x} od ${y}`,
      [LanguagesEnum.MS as string]: (x: number, y: number) =>
        `Soalan ${x} daripada ${y}`,
      [LanguagesEnum.HI as string]: (x: number, y: number) =>
        `प्रश्न ${x} में से ${y}`,
      [LanguagesEnum.SQ as string]: (x: number, y: number) =>
        `Pyetja ${x} nga ${y}`,
      [LanguagesEnum.BA as string]: (x: number, y: number) =>
        `Pitanje ${x} od ${y}`,
      [LanguagesEnum.MK as string]: (x: number, y: number) =>
        `Прашање ${x} од ${y}`,
      [LanguagesEnum.IS as string]: (x: number, y: number) =>
        `Spurning ${x} af ${y}`,
      [LanguagesEnum.LB as string]: (x: number, y: number) =>
        `Fro ${x} vun ${y}`,
      [LanguagesEnum.BR as string]: (x: number, y: number) =>
        `Pergunta ${x} de ${y}`,
      [LanguagesEnum.UR as string]: (x: number, y: number) =>
        `سوال ${x} از ${y}`,
      [LanguagesEnum.TL as string]: (x: number, y: number) =>
        `Tanong ${x} sa ${y}`,
      [LanguagesEnum.TA as string]: (x: number, y: number) =>
        `கேள்வி ${x} / ${y}`,
      [LanguagesEnum.BN as string]: (x: number, y: number) =>
        `প্রশ্ন ${x} এর মধ্যে ${y}`,
      [LanguagesEnum.FA as string]: (x: number, y: number) =>
        `سؤال ${x} از ${y}`,
    },
  },
  slide: {
    currentOutOfTotal: {
      [LanguagesEnum.EN as string]: (x: number, y: number) =>
        `Slide ${x} out of ${y}`,
      [LanguagesEnum.DK as string]: (x: number, y: number) =>
        `Slide ${x} ud af ${y}`,
      [LanguagesEnum.SE as string]: (x: number, y: number) =>
        `Bild ${x} av ${y}`,
      [LanguagesEnum.NO as string]: (x: number, y: number) =>
        `Lysbilde ${x} av ${y}`,
      [LanguagesEnum.DE as string]: (x: number, y: number) =>
        `Folie ${x} von ${y}`,
      [LanguagesEnum.KL as string]: (x: number, y: number) =>
        `Slide ${x} tamarmik ${y}`,
      [LanguagesEnum.AR as string]: (x: number, y: number) =>
        `الشريحة ${x} من ${y}`,
      [LanguagesEnum.CZ as string]: (x: number, y: number) =>
        `Snímek ${x} z ${y}`,
      [LanguagesEnum.ES as string]: (x: number, y: number) =>
        `Diapositiva ${x} de ${y}`,
      [LanguagesEnum.FI as string]: (x: number, y: number) => `Dia ${x} / ${y}`,
      [LanguagesEnum.FR as string]: (x: number, y: number) =>
        `Diapositive ${x} sur ${y}`,
      [LanguagesEnum.IT as string]: (x: number, y: number) =>
        `Diapositiva ${x} di ${y}`,
      [LanguagesEnum.LT as string]: (x: number, y: number) =>
        `Skaidrė ${x} iš ${y}`,
      [LanguagesEnum.LV as string]: (x: number, y: number) =>
        `Slīde ${x} no ${y}`,
      [LanguagesEnum.NL as string]: (x: number, y: number) =>
        `Dia ${x} van ${y}`,
      [LanguagesEnum.PG as string]: (x: number, y: number) =>
        `Slide ${x} de ${y}`,
      [LanguagesEnum.PL as string]: (x: number, y: number) =>
        `Slajd ${x} z ${y}`,
      [LanguagesEnum.TR as string]: (x: number, y: number) =>
        `Slayt ${x} / ${y}`,
      [LanguagesEnum.VI as string]: (x: number, y: number) =>
        `Trang trình chiếu ${x} trên ${y}`,
      [LanguagesEnum.ZH as string]: (x: number, y: number) =>
        `幻灯片${x}，共${y}`,
      [LanguagesEnum.RO as string]: (x: number, y: number) =>
        `Slide ${x} din ${y}`,
      [LanguagesEnum.UA as string]: (x: number, y: number) =>
        `Слайд ${x} із ${y}`,
      [LanguagesEnum.BG as string]: (x: number, y: number) =>
        `Слайд ${x} от ${y}`,
      [LanguagesEnum.EL as string]: (x: number, y: number) =>
        `Διαφάνεια ${x} από ${y}`,
      [LanguagesEnum.ET as string]: (x: number, y: number) =>
        `Slaid ${x} / ${y}`,
      [LanguagesEnum.HE as string]: (x: number, y: number) =>
        `שקף ${x} מתוך ${y}`,
      [LanguagesEnum.HU as string]: (x: number, y: number) => `Dia ${x} / ${y}`,
      [LanguagesEnum.ID as string]: (x: number, y: number) =>
        `Slide ${x} dari ${y}`,
      [LanguagesEnum.JA as string]: (x: number, y: number) =>
        `スライド ${x} / ${y}`,
      [LanguagesEnum.KO as string]: (x: number, y: number) =>
        `슬라이드 ${x} / ${y}`,
      [LanguagesEnum.RU as string]: (x: number, y: number) =>
        `Слайд ${x} из ${y}`,
      [LanguagesEnum.SK as string]: (x: number, y: number) =>
        `Snímka ${x} z ${y}`,
      [LanguagesEnum.SL as string]: (x: number, y: number) =>
        `Diapozitiv ${x} od ${y}`,
      [LanguagesEnum.TH as string]: (x: number, y: number) =>
        `สไลด์ ${x} จาก ${y}`,
      [LanguagesEnum.HR as string]: (x: number, y: number) =>
        `Slajd ${x} od ${y}`,
      [LanguagesEnum.SR as string]: (x: number, y: number) =>
        `Slajd ${x} od ${y}`,
      [LanguagesEnum.MS as string]: (x: number, y: number) =>
        `Slaid ${x} dari ${y}`,
      [LanguagesEnum.HI as string]: (x: number, y: number) =>
        `स्लाइड ${x} में से ${y}`,
      [LanguagesEnum.SQ as string]: (x: number, y: number) =>
        `Slajdi ${x} nga ${y}`,
      [LanguagesEnum.BA as string]: (x: number, y: number) =>
        `Slajd ${x} od ${y}`,
      [LanguagesEnum.MK as string]: (x: number, y: number) =>
        `Слајд ${x} од ${y}`,
      [LanguagesEnum.IS as string]: (x: number, y: number) =>
        `Skyggna ${x} af ${y}`,
      [LanguagesEnum.LB as string]: (x: number, y: number) =>
        `Rutsch ${x} vun ${y}`,
      [LanguagesEnum.BR as string]: (x: number, y: number) =>
        `Slide ${x} de ${y}`,
      [LanguagesEnum.UR as string]: (x: number, y: number) =>
        `سلائیڈ ${x} از ${y}`,
      [LanguagesEnum.TL as string]: (x: number, y: number) =>
        `Slide ${x} sa ${y}`,
      [LanguagesEnum.TA as string]: (x: number, y: number) =>
        `ஸ்லைடு ${x} / ${y}`,
      [LanguagesEnum.BN as string]: (x: number, y: number) =>
        `স্লাইড ${x} এর মধ্যে ${y}`,
      [LanguagesEnum.FA as string]: (x: number, y: number) =>
        `اسلاید ${x} از ${y}`,
    },
  },
  buttons: {
    backToCourse: {
      [LanguagesEnum.EN as string]: 'Back to course',
      [LanguagesEnum.DK as string]: 'Tilbage til kurset',
      [LanguagesEnum.SE as string]: 'Tillbaka till kursen',
      [LanguagesEnum.NO as string]: 'Tilbake til kurset',
      [LanguagesEnum.DE as string]: 'Zurück zum Kurs',
      [LanguagesEnum.KL as string]: 'Ilinniartitsissummut uterit',
      [LanguagesEnum.AR as string]: 'العودة إلى المقرر',
      [LanguagesEnum.CZ as string]: 'Zpět ke kurzu',
      [LanguagesEnum.ES as string]: 'Volver al curso',
      [LanguagesEnum.FI as string]: 'Takaisin kurssiin',
      [LanguagesEnum.FR as string]: 'Retour au cours',
      [LanguagesEnum.IT as string]: 'Torna al corso',
      [LanguagesEnum.LT as string]: 'Grįžti į kursą',
      [LanguagesEnum.LV as string]: 'Atpakaļ uz kursu',
      [LanguagesEnum.NL as string]: 'Terug naar de cursus',
      [LanguagesEnum.PG as string]: 'Voltar ao curso',
      [LanguagesEnum.PL as string]: 'Powrót do kursu',
      [LanguagesEnum.TR as string]: 'Kursa geri dön',
      [LanguagesEnum.VI as string]: 'Quay lại khóa học',
      [LanguagesEnum.ZH as string]: '返回课程',
      [LanguagesEnum.RO as string]: 'Înapoi la curs',
      [LanguagesEnum.UA as string]: 'Назад до курсу',
      [LanguagesEnum.BG as string]: 'Назад към курса',
      [LanguagesEnum.EL as string]: 'Επιστροφή στο μάθημα',
      [LanguagesEnum.ET as string]: 'Tagasi kursusele',
      [LanguagesEnum.HE as string]: 'חזרה לקורס',
      [LanguagesEnum.HU as string]: 'Vissza a kurzusra',
      [LanguagesEnum.ID as string]: 'Kembali ke kursus',
      [LanguagesEnum.JA as string]: 'コースに戻る',
      [LanguagesEnum.KO as string]: '코스로 돌아가기',
      [LanguagesEnum.RU as string]: 'Вернуться к курсу',
      [LanguagesEnum.SK as string]: 'Späť na kurz',
      [LanguagesEnum.SL as string]: 'Nazaj na tečaj',
      [LanguagesEnum.TH as string]: 'กลับไปที่หลักสูตร',
      [LanguagesEnum.HR as string]: 'Natrag na tečaj',
      [LanguagesEnum.SR as string]: 'Nazad na kurs',
      [LanguagesEnum.MS as string]: 'Kembali ke kursus',
      [LanguagesEnum.HI as string]: 'पाठ्यक्रम पर वापस जाएँ',
      [LanguagesEnum.SQ as string]: 'Kthehu te kursi',
      [LanguagesEnum.BA as string]: 'Nazad na kurs',
      [LanguagesEnum.MK as string]: 'Назад кон курсот',
      [LanguagesEnum.IS as string]: 'Til baka í námskeið',
      [LanguagesEnum.LB as string]: 'Zeréck op de Cours',
      [LanguagesEnum.BR as string]: 'Voltar ao curso',
      [LanguagesEnum.UR as string]: 'کورس پر واپس جائیں',
      [LanguagesEnum.TL as string]: 'Bumalik sa kurso',
      [LanguagesEnum.TA as string]: 'பாடநெறிக்குத் திரும்பு',
      [LanguagesEnum.BN as string]: 'কোর্সে ফিরে যান',
      [LanguagesEnum.FA as string]: 'بازگشت به دوره',
    },
    next: {
      [LanguagesEnum.EN as string]: 'Next',
      [LanguagesEnum.DK as string]: 'Næste',
      [LanguagesEnum.SE as string]: 'Nästa',
      [LanguagesEnum.NO as string]: 'Neste',
      [LanguagesEnum.DE as string]: 'Weiter',
      [LanguagesEnum.KL as string]: 'Tullia',
      [LanguagesEnum.AR as string]: 'التالي',
      [LanguagesEnum.CZ as string]: 'Další',
      [LanguagesEnum.ES as string]: 'Siguiente',
      [LanguagesEnum.FI as string]: 'Seuraava',
      [LanguagesEnum.FR as string]: 'Suivant',
      [LanguagesEnum.IT as string]: 'Avanti',
      [LanguagesEnum.LT as string]: 'Kitas',
      [LanguagesEnum.LV as string]: 'Nākamais',
      [LanguagesEnum.NL as string]: 'Volgende',
      [LanguagesEnum.PG as string]: 'Seguinte',
      [LanguagesEnum.PL as string]: 'Dalej',
      [LanguagesEnum.TR as string]: 'Sonraki',
      [LanguagesEnum.VI as string]: 'Tiếp theo',
      [LanguagesEnum.ZH as string]: '下一题',
      [LanguagesEnum.RO as string]: 'Următorul',
      [LanguagesEnum.UA as string]: 'Далі',
      [LanguagesEnum.BG as string]: 'Напред',
      [LanguagesEnum.EL as string]: 'Επόμενο',
      [LanguagesEnum.ET as string]: 'Edasi',
      [LanguagesEnum.HE as string]: 'הבא',
      [LanguagesEnum.HU as string]: 'Következő',
      [LanguagesEnum.ID as string]: 'Selanjutnya',
      [LanguagesEnum.JA as string]: '次へ',
      [LanguagesEnum.KO as string]: '다음',
      [LanguagesEnum.RU as string]: 'Далее',
      [LanguagesEnum.SK as string]: 'Ďalšie',
      [LanguagesEnum.SL as string]: 'Naprej',
      [LanguagesEnum.TH as string]: 'ถัดไป',
      [LanguagesEnum.HR as string]: 'Dalje',
      [LanguagesEnum.SR as string]: 'Dalje',
      [LanguagesEnum.MS as string]: 'Seterusnya',
      [LanguagesEnum.HI as string]: 'आगे',
      [LanguagesEnum.SQ as string]: 'Tjetra',
      [LanguagesEnum.BA as string]: 'Dalje',
      [LanguagesEnum.MK as string]: 'Напред',
      [LanguagesEnum.IS as string]: 'Áfram',
      [LanguagesEnum.LB as string]: 'Weider',
      [LanguagesEnum.BR as string]: 'Avançar',
      [LanguagesEnum.UR as string]: 'آگے',
      [LanguagesEnum.TL as string]: 'Susunod',
      [LanguagesEnum.TA as string]: 'அடுத்து',
      [LanguagesEnum.BN as string]: 'পরেরটি',
      [LanguagesEnum.FA as string]: 'ادامه',
    },
    retry: {
      [LanguagesEnum.EN as string]: 'Retry',
      [LanguagesEnum.DK as string]: 'Prøv igen',
      [LanguagesEnum.SE as string]: 'Försök igen',
      [LanguagesEnum.NO as string]: 'Prøv på nytt',
      [LanguagesEnum.DE as string]: 'Wiederholen',
      [LanguagesEnum.KL as string]: 'Misileqqiguk',
      [LanguagesEnum.AR as string]: 'إعادة المحاولة',
      [LanguagesEnum.CZ as string]: 'Zkusit znovu',
      [LanguagesEnum.ES as string]: 'Reintentar',
      [LanguagesEnum.FI as string]: 'Yritä uudelleen',
      [LanguagesEnum.FR as string]: 'Réessayer',
      [LanguagesEnum.IT as string]: 'Riprova',
      [LanguagesEnum.LT as string]: 'Bandykite dar kartą',
      [LanguagesEnum.LV as string]: 'Mēģināt vēlreiz',
      [LanguagesEnum.NL as string]: 'Opnieuw proberen',
      [LanguagesEnum.PG as string]: 'Tentar novamente',
      [LanguagesEnum.PL as string]: 'Spróbuj ponownie',
      [LanguagesEnum.TR as string]: 'Tekrar dene',
      [LanguagesEnum.VI as string]: 'Thử lại',
      [LanguagesEnum.ZH as string]: '重试',
      [LanguagesEnum.RO as string]: 'Reîncercați',
      [LanguagesEnum.UA as string]: 'Спробувати ще раз',
      [LanguagesEnum.BG as string]: 'Опитайте отново',
      [LanguagesEnum.EL as string]: 'Δοκιμάστε ξανά',
      [LanguagesEnum.ET as string]: 'Proovi uuesti',
      [LanguagesEnum.HE as string]: 'נסה שוב',
      [LanguagesEnum.HU as string]: 'Próbálja újra',
      [LanguagesEnum.ID as string]: 'Coba lagi',
      [LanguagesEnum.JA as string]: '再試行',
      [LanguagesEnum.KO as string]: '다시 시도',
      [LanguagesEnum.RU as string]: 'Повторить',
      [LanguagesEnum.SK as string]: 'Skúsiť znova',
      [LanguagesEnum.SL as string]: 'Poskusi znova',
      [LanguagesEnum.TH as string]: 'ลองอีกครั้ง',
      [LanguagesEnum.HR as string]: 'Ponovi',
      [LanguagesEnum.SR as string]: 'Ponovi',
      [LanguagesEnum.MS as string]: 'Cuba lagi',
      [LanguagesEnum.HI as string]: 'फिर से प्रयास करें',
      [LanguagesEnum.SQ as string]: 'Provo sërish',
      [LanguagesEnum.BA as string]: 'Ponovi',
      [LanguagesEnum.MK as string]: 'Повтори',
      [LanguagesEnum.IS as string]: 'Reyna aftur',
      [LanguagesEnum.LB as string]: 'Nach eng Kéier',
      [LanguagesEnum.BR as string]: 'Tentar novamente',
      [LanguagesEnum.UR as string]: 'دوبارہ کوشش کریں',
      [LanguagesEnum.TL as string]: 'Subukan ulit',
      [LanguagesEnum.TA as string]: 'மீண்டும் முயற்சிக்கவும்',
      [LanguagesEnum.BN as string]: 'আবার চেষ্টা করুন',
      [LanguagesEnum.FA as string]: 'تلاش دوباره',
    },
    finish: {
      [LanguagesEnum.EN as string]: 'Finish',
      [LanguagesEnum.DK as string]: 'Gennemfør',
      [LanguagesEnum.SE as string]: 'Slutför',
      [LanguagesEnum.NO as string]: 'Fullfør',
      [LanguagesEnum.DE as string]: 'Abschließen',
      [LanguagesEnum.KL as string]: 'Naammassiguk',
      [LanguagesEnum.AR as string]: 'إكمال',
      [LanguagesEnum.CZ as string]: 'Dokončit',
      [LanguagesEnum.ES as string]: 'Completar',
      [LanguagesEnum.FI as string]: 'Suorita loppuun',
      [LanguagesEnum.FR as string]: 'Terminer',
      [LanguagesEnum.IT as string]: 'Completa',
      [LanguagesEnum.LT as string]: 'Užbaikite',
      [LanguagesEnum.LV as string]: 'Pabeidziet',
      [LanguagesEnum.NL as string]: 'Voltooien',
      [LanguagesEnum.PG as string]: 'Concluir',
      [LanguagesEnum.PL as string]: 'Ukończ',
      [LanguagesEnum.TR as string]: 'Tamamla',
      [LanguagesEnum.VI as string]: 'Hoàn thành',
      [LanguagesEnum.ZH as string]: '完成',
      [LanguagesEnum.RO as string]: 'Finalizați',
      [LanguagesEnum.UA as string]: 'Завершити',
      [LanguagesEnum.BG as string]: 'Завърши',
      [LanguagesEnum.EL as string]: 'Ολοκλήρωση',
      [LanguagesEnum.ET as string]: 'Lõpeta',
      [LanguagesEnum.HE as string]: 'סיים',
      [LanguagesEnum.HU as string]: 'Befejezés',
      [LanguagesEnum.ID as string]: 'Selesai',
      [LanguagesEnum.JA as string]: '完了',
      [LanguagesEnum.KO as string]: '완료',
      [LanguagesEnum.RU as string]: 'Завершить',
      [LanguagesEnum.SK as string]: 'Dokončiť',
      [LanguagesEnum.SL as string]: 'Zaključi',
      [LanguagesEnum.TH as string]: 'เสร็จสิ้น',
      [LanguagesEnum.HR as string]: 'Završi',
      [LanguagesEnum.SR as string]: 'Završi',
      [LanguagesEnum.MS as string]: 'Selesai',
      [LanguagesEnum.HI as string]: 'पूरा करें',
      [LanguagesEnum.SQ as string]: 'Përfundo',
      [LanguagesEnum.BA as string]: 'Završi',
      [LanguagesEnum.MK as string]: 'Заврши',
      [LanguagesEnum.IS as string]: 'Klára',
      [LanguagesEnum.LB as string]: 'Ofschléissen',
      [LanguagesEnum.BR as string]: 'Concluir',
      [LanguagesEnum.UR as string]: 'مکمل کریں',
      [LanguagesEnum.TL as string]: 'Tapusin',
      [LanguagesEnum.TA as string]: 'முடிக்கவும்',
      [LanguagesEnum.BN as string]: 'সম্পন্ন করুন',
      [LanguagesEnum.FA as string]: 'پایان',
    },
    previous: {
      [LanguagesEnum.EN as string]: 'Previous',
      [LanguagesEnum.DK as string]: 'Forrige',
      [LanguagesEnum.SE as string]: 'Föregående',
      [LanguagesEnum.NO as string]: 'Forrige',
      [LanguagesEnum.DE as string]: 'Zurück',
      [LanguagesEnum.KL as string]: 'Kingumut',
      [LanguagesEnum.AR as string]: 'السابق',
      [LanguagesEnum.CZ as string]: 'Předchozí',
      [LanguagesEnum.ES as string]: 'Anterior',
      [LanguagesEnum.FI as string]: 'Edellinen',
      [LanguagesEnum.FR as string]: 'Précédent',
      [LanguagesEnum.IT as string]: 'Precedente',
      [LanguagesEnum.LT as string]: 'Ankstesnis',
      [LanguagesEnum.LV as string]: 'Iepriekšējais',
      [LanguagesEnum.NL as string]: 'Vorige',
      [LanguagesEnum.PG as string]: 'Anterior',
      [LanguagesEnum.PL as string]: 'Poprzednie',
      [LanguagesEnum.TR as string]: 'Önceki',
      [LanguagesEnum.VI as string]: 'Trước',
      [LanguagesEnum.ZH as string]: '上一页',
      [LanguagesEnum.RO as string]: 'Înapoi',
      [LanguagesEnum.UA as string]: 'Назад',
      [LanguagesEnum.BG as string]: 'Предишен',
      [LanguagesEnum.EL as string]: 'Προηγούμενο',
      [LanguagesEnum.ET as string]: 'Tagasi',
      [LanguagesEnum.HE as string]: 'הקודם',
      [LanguagesEnum.HU as string]: 'Előző',
      [LanguagesEnum.ID as string]: 'Sebelumnya',
      [LanguagesEnum.JA as string]: '前へ',
      [LanguagesEnum.KO as string]: '이전',
      [LanguagesEnum.RU as string]: 'Назад',
      [LanguagesEnum.SK as string]: 'Predchádzajúce',
      [LanguagesEnum.SL as string]: 'Nazaj',
      [LanguagesEnum.TH as string]: 'ก่อนหน้า',
      [LanguagesEnum.HR as string]: 'Nazad',
      [LanguagesEnum.SR as string]: 'Nazad',
      [LanguagesEnum.MS as string]: 'Sebelumnya',
      [LanguagesEnum.HI as string]: 'पिछला',
      [LanguagesEnum.SQ as string]: 'Kthehu',
      [LanguagesEnum.BA as string]: 'Nazad',
      [LanguagesEnum.MK as string]: 'Назад',
      [LanguagesEnum.IS as string]: 'Til baka',
      [LanguagesEnum.LB as string]: 'Zeréck',
      [LanguagesEnum.BR as string]: 'Voltar',
      [LanguagesEnum.UR as string]: 'واپس',
      [LanguagesEnum.TL as string]: 'Bumalik',
      [LanguagesEnum.TA as string]: 'பின்செல்',
      [LanguagesEnum.BN as string]: 'পেছনে যান',
      [LanguagesEnum.FA as string]: 'بازگشت',
    },
    submit: {
      [LanguagesEnum.EN as string]: 'Submit',
      [LanguagesEnum.DK as string]: 'Indsend',
      [LanguagesEnum.SE as string]: 'Skicka in',
      [LanguagesEnum.NO as string]: 'Send inn',
      [LanguagesEnum.DE as string]: 'Absenden',
      [LanguagesEnum.KL as string]: 'Nassiguk',
      [LanguagesEnum.AR as string]: 'إرسال',
      [LanguagesEnum.CZ as string]: 'Odeslat',
      [LanguagesEnum.ES as string]: 'Enviar',
      [LanguagesEnum.FI as string]: 'Lähetä',
      [LanguagesEnum.FR as string]: 'Envoyer',
      [LanguagesEnum.IT as string]: 'Invia',
      [LanguagesEnum.LT as string]: 'Pateikti',
      [LanguagesEnum.LV as string]: 'Iesniegt',
      [LanguagesEnum.NL as string]: 'Indienen',
      [LanguagesEnum.PG as string]: 'Enviar',
      [LanguagesEnum.PL as string]: 'Prześlij',
      [LanguagesEnum.TR as string]: 'Gönder',
      [LanguagesEnum.VI as string]: 'Gửi',
      [LanguagesEnum.ZH as string]: '提交',
      [LanguagesEnum.RO as string]: 'Trimiteți',
      [LanguagesEnum.UA as string]: 'Надіслати',
      [LanguagesEnum.BG as string]: 'Изпрати',
      [LanguagesEnum.EL as string]: 'Υποβολή',
      [LanguagesEnum.ET as string]: 'Esita',
      [LanguagesEnum.HE as string]: 'שלח',
      [LanguagesEnum.HU as string]: 'Küldés',
      [LanguagesEnum.ID as string]: 'Kirim',
      [LanguagesEnum.JA as string]: '送信',
      [LanguagesEnum.KO as string]: '제출',
      [LanguagesEnum.RU as string]: 'Отправить',
      [LanguagesEnum.SK as string]: 'Odoslať',
      [LanguagesEnum.SL as string]: 'Pošlji',
      [LanguagesEnum.TH as string]: 'ส่ง',
      [LanguagesEnum.HR as string]: 'Predaj',
      [LanguagesEnum.SR as string]: 'Predaj',
      [LanguagesEnum.MS as string]: 'Hantar jawapan',
      [LanguagesEnum.HI as string]: 'जमा करें',
      [LanguagesEnum.SQ as string]: 'Dorëzo',
      [LanguagesEnum.BA as string]: 'Predaj',
      [LanguagesEnum.MK as string]: 'Предај',
      [LanguagesEnum.IS as string]: 'Skila',
      [LanguagesEnum.LB as string]: 'Ofginn',
      [LanguagesEnum.BR as string]: 'Enviar respostas',
      [LanguagesEnum.UR as string]: 'جمع کریں',
      [LanguagesEnum.TL as string]: 'Isumite',
      [LanguagesEnum.TA as string]: 'சமர்ப்பிக்கவும்',
      [LanguagesEnum.BN as string]: 'জমা দিন',
      [LanguagesEnum.FA as string]: 'ارسال',
    },
    continue: {
      [LanguagesEnum.EN as string]: 'Continue',
      [LanguagesEnum.DK as string]: 'Fortsæt',
      [LanguagesEnum.SE as string]: 'Fortsätt',
      [LanguagesEnum.NO as string]: 'Fortsett',
      [LanguagesEnum.DE as string]: 'Weiter',
      [LanguagesEnum.KL as string]: 'Sumiiffimmut tullermut ingerlaqqigit',
      [LanguagesEnum.AR as string]: 'متابعة',
      [LanguagesEnum.CZ as string]: 'Pokračovat',
      [LanguagesEnum.ES as string]: 'Continuar',
      [LanguagesEnum.FI as string]: 'Jatka',
      [LanguagesEnum.FR as string]: 'Continuer',
      [LanguagesEnum.IT as string]: 'Continua',
      [LanguagesEnum.LT as string]: 'Tęsti',
      [LanguagesEnum.LV as string]: 'Turpināt',
      [LanguagesEnum.NL as string]: 'Doorgaan',
      [LanguagesEnum.PG as string]: 'Continuar',
      [LanguagesEnum.PL as string]: 'Kontynuuj',
      [LanguagesEnum.TR as string]: 'Devam et',
      [LanguagesEnum.VI as string]: 'Tiếp tục',
      [LanguagesEnum.ZH as string]: '继续',
      [LanguagesEnum.RO as string]: 'Continuați',
      [LanguagesEnum.UA as string]: 'Продовжити',
      [LanguagesEnum.BG as string]: 'Продължи',
      [LanguagesEnum.EL as string]: 'Συνέχεια',
      [LanguagesEnum.ET as string]: 'Jätka',
      [LanguagesEnum.HE as string]: 'המשך',
      [LanguagesEnum.HU as string]: 'Folytatás',
      [LanguagesEnum.ID as string]: 'Lanjutkan',
      [LanguagesEnum.JA as string]: '続ける',
      [LanguagesEnum.KO as string]: '계속',
      [LanguagesEnum.RU as string]: 'Продолжить',
      [LanguagesEnum.SK as string]: 'Pokračovať',
      [LanguagesEnum.SL as string]: 'Nadaljuj',
      [LanguagesEnum.TH as string]: 'ดำเนินการต่อ',
      [LanguagesEnum.HR as string]: 'Nastavi',
      [LanguagesEnum.SR as string]: 'Nastavi',
      [LanguagesEnum.MS as string]: 'Teruskan',
      [LanguagesEnum.HI as string]: 'आगे बढ़ें',
      [LanguagesEnum.SQ as string]: 'Vazhdo',
      [LanguagesEnum.BA as string]: 'Nastavi',
      [LanguagesEnum.MK as string]: 'Продолжи',
      [LanguagesEnum.IS as string]: 'Áfram',
      [LanguagesEnum.LB as string]: 'Weider',
      [LanguagesEnum.BR as string]: 'Continuar',
      [LanguagesEnum.UR as string]: 'جاری رکھیں',
      [LanguagesEnum.TL as string]: 'Ituloy',
      [LanguagesEnum.TA as string]: 'தொடரவும்',
      [LanguagesEnum.BN as string]: 'চালিয়ে যান',
      [LanguagesEnum.FA as string]: 'ادامه',
    },
    goToContent: {
      [LanguagesEnum.EN as string]: 'Go to your content page',
      [LanguagesEnum.DK as string]: 'Gå til din træningsside',
      [LanguagesEnum.SE as string]: 'Gå till din träningssida',
      [LanguagesEnum.NO as string]: 'Gå til treningssiden din',
      [LanguagesEnum.DE as string]: 'Gehen Sie zu Ihrer Trainingsseite',
      [LanguagesEnum.KL as string]: 'Træningsside-mut ingerlaqqigit',
      [LanguagesEnum.AR as string]: 'انتقل إلى صفحة التدريب الخاصة بك',
      [LanguagesEnum.CZ as string]: 'Přejít na svou stránku školení',
      [LanguagesEnum.ES as string]: 'Ir a tu página de formación',
      [LanguagesEnum.FI as string]: 'Siirry koulutussivullesi',
      [LanguagesEnum.FR as string]: 'Aller à votre page de formation',
      [LanguagesEnum.IT as string]: 'Vai alla tua pagina di formazione',
      [LanguagesEnum.LT as string]: 'Eikite į savo mokymų puslapį',
      [LanguagesEnum.LV as string]: 'Dodieties uz savu mācību lapu',
      [LanguagesEnum.NL as string]: 'Ga naar je trainingspagina',
      [LanguagesEnum.PG as string]: 'Vá para a sua página de treino',
      [LanguagesEnum.PL as string]: 'Przejdź do swojej strony szkoleniowej',
      [LanguagesEnum.TR as string]: 'Eğitim sayfanıza gidin',
      [LanguagesEnum.VI as string]: 'Đi tới trang đào tạo của bạn',
      [LanguagesEnum.ZH as string]: '前往您的培训页面',
      [LanguagesEnum.RO as string]: 'Mergeți la pagina dvs. de instruire',
      [LanguagesEnum.UA as string]: 'Перейдіть на сторінку навчання',
      [LanguagesEnum.BG as string]: 'Отидете на страницата си за обучение',
      [LanguagesEnum.EL as string]: 'Μεταβείτε στη σελίδα εκπαίδευσής σας',
      [LanguagesEnum.ET as string]: 'Mine oma sisu lehele',
      [LanguagesEnum.HE as string]: 'עבור לדף ההדרכה שלך',
      [LanguagesEnum.HU as string]: 'Lépjen az oktatási oldalára',
      [LanguagesEnum.ID as string]: 'Buka halaman pelatihan Anda',
      [LanguagesEnum.JA as string]: 'トレーニングページに移動',
      [LanguagesEnum.KO as string]: '교육 페이지로 이동',
      [LanguagesEnum.RU as string]: 'Перейдите на страницу обучения',
      [LanguagesEnum.SK as string]: 'Prejdite na svoju stránku školenia',
      [LanguagesEnum.SL as string]: 'Pojdite na svojo stran za usposabljanje',
      [LanguagesEnum.TH as string]: 'ไปที่หน้าฝึกอบรมของคุณ',
      [LanguagesEnum.HR as string]: 'Idi na svoju stranicu sadržaja',
      [LanguagesEnum.SR as string]: 'Idi na svoju stranicu sadržaja',
      [LanguagesEnum.MS as string]: 'Pergi ke halaman kandungan anda',
      [LanguagesEnum.HI as string]: 'अपने सामग्री पृष्ठ पर जाएँ',
      [LanguagesEnum.SQ as string]: 'Shko te faqja e përmbajtjes',
      [LanguagesEnum.BA as string]: 'Idi na svoju stranicu sadržaja',
      [LanguagesEnum.MK as string]: 'Оди на твојата страница со содржина',
      [LanguagesEnum.IS as string]: 'Fara á efnissíðuna þína',
      [LanguagesEnum.LB as string]: 'Géi op deng Inhaltssäit',
      [LanguagesEnum.BR as string]: 'Ir para sua página de conteúdo',
      [LanguagesEnum.UR as string]: 'اپنے مواد کے صفحے پر جائیں',
      [LanguagesEnum.TL as string]: 'Pumunta sa iyong pahina ng nilalaman',
      [LanguagesEnum.TA as string]: 'உங்கள் உள்ளடக்கப் பக்கத்திற்கு செல்லவும்',
      [LanguagesEnum.BN as string]: 'আপনার কনটেন্ট পেজে যান',
      [LanguagesEnum.FA as string]: 'رفتن به صفحه محتوای شما',
    },
    closeInfoBox: {
      [LanguagesEnum.EN as string]: 'Close info box',
      [LanguagesEnum.DK as string]: 'Luk infoboks',
      [LanguagesEnum.SE as string]: 'Stäng informationsrutan',
      [LanguagesEnum.NO as string]: 'Lukk infoboksen',
      [LanguagesEnum.DE as string]: 'Infobox schließen',
      [LanguagesEnum.KL as string]: 'Nalunaarusiaq matueruk',
      [LanguagesEnum.AR as string]: 'إغلاق مربع المعلومات',
      [LanguagesEnum.CZ as string]: 'Zavřít informační pole',
      [LanguagesEnum.ES as string]: 'Cerrar cuadro de información',
      [LanguagesEnum.FI as string]: 'Sulje tietoruutu',
      [LanguagesEnum.FR as string]: 'Fermer la boîte info',
      [LanguagesEnum.IT as string]: 'Chiudi la casella informativa',
      [LanguagesEnum.LT as string]: 'Uždaryti informacinį laukelį',
      [LanguagesEnum.LV as string]: 'Aizvērt informācijas lodziņu',
      [LanguagesEnum.NL as string]: 'Informatievak sluiten',
      [LanguagesEnum.PG as string]: 'Fechar caixa de informação',
      [LanguagesEnum.PL as string]: 'Zamknij pole informacyjne',
      [LanguagesEnum.TR as string]: 'Bilgi kutusunu kapat',
      [LanguagesEnum.VI as string]: 'Đóng hộp thông tin',
      [LanguagesEnum.ZH as string]: '关闭信息框',
      [LanguagesEnum.RO as string]: 'Închideți caseta informativă',
      [LanguagesEnum.UA as string]: 'Закрити інформаційне поле',
      [LanguagesEnum.BG as string]: 'Затвори информационното поле',
      [LanguagesEnum.EL as string]: 'Κλείσιμο πλαισίου πληροφοριών',
      [LanguagesEnum.ET as string]: 'Sulge infoväli',
      [LanguagesEnum.HE as string]: 'סגור תיבת מידע',
      [LanguagesEnum.HU as string]: 'Infó mező bezárása',
      [LanguagesEnum.ID as string]: 'Tutup kotak info',
      [LanguagesEnum.JA as string]: '情報ボックスを閉じる',
      [LanguagesEnum.KO as string]: '정보 상자 닫기',
      [LanguagesEnum.RU as string]: 'Закрыть информационное окно',
      [LanguagesEnum.SK as string]: 'Zavrieť informačné pole',
      [LanguagesEnum.SL as string]: 'Zapri informacijsko polje',
      [LanguagesEnum.TH as string]: 'ปิดกล่องข้อมูล',
      [LanguagesEnum.HR as string]: 'Zatvori informacijski okvir',
      [LanguagesEnum.SR as string]: 'Zatvori informacioni okvir',
      [LanguagesEnum.MS as string]: 'Tutup kotak maklumat',
      [LanguagesEnum.HI as string]: 'जानकारी बॉक्स बंद करें',
      [LanguagesEnum.SQ as string]: 'Mbylle kutinë e informacionit',
      [LanguagesEnum.BA as string]: 'Zatvori info okvir',
      [LanguagesEnum.MK as string]: 'Затвори информациска кутија',
      [LanguagesEnum.IS as string]: 'Loka upplýsingarreit',
      [LanguagesEnum.LB as string]: 'Informatiounskëscht zoumaachen',
      [LanguagesEnum.BR as string]: 'Fechar caixa de informação',
      [LanguagesEnum.UR as string]: 'معلوماتی خانہ بند کریں',
      [LanguagesEnum.TL as string]: 'Isara ang info box',
      [LanguagesEnum.TA as string]: 'தகவல் பெட்டியை மூடு',
      [LanguagesEnum.BN as string]: 'তথ্য বাক্স বন্ধ করুন',
      [LanguagesEnum.FA as string]: 'بستن جعبه اطلاعات',
    },
  },
  messages: {
    almostDone: {
      [LanguagesEnum.EN as string]: 'You’re almost done!',
      [LanguagesEnum.DK as string]: 'Du er næsten færdig!',
      [LanguagesEnum.SE as string]: 'Du är nästan klar!',
      [LanguagesEnum.NO as string]: 'Du er nesten ferdig!',
      [LanguagesEnum.DE as string]: 'Sie sind fast fertig!',
      [LanguagesEnum.KL as string]: 'Piariiliivipputit!',
      [LanguagesEnum.AR as string]: 'لقد أوشكت على الانتهاء!',
      [LanguagesEnum.CZ as string]: 'Už jste skoro hotovi!',
      [LanguagesEnum.ES as string]: '¡Ya casi terminas!',
      [LanguagesEnum.FI as string]: 'Olet melkein valmis!',
      [LanguagesEnum.FR as string]: 'Vous avez presque terminé !',
      [LanguagesEnum.IT as string]: 'Sei quasi alla fine!',
      [LanguagesEnum.LT as string]: 'Jau beveik baigėte!',
      [LanguagesEnum.LV as string]: 'Jūs esat gandrīz pabeidzis!',
      [LanguagesEnum.NL as string]: 'Je bent bijna klaar!',
      [LanguagesEnum.PG as string]: 'Você está quase terminando!',
      [LanguagesEnum.PL as string]: 'Już prawie skończyłeś!',
      [LanguagesEnum.TR as string]: 'Neredeyse bitirdiniz!',
      [LanguagesEnum.VI as string]: 'Bạn sắp hoàn thành rồi!',
      [LanguagesEnum.ZH as string]: '你快完成了！',
      [LanguagesEnum.RO as string]: 'Aproape ați terminat!',
      [LanguagesEnum.UA as string]: 'Ви майже закінчили!',
      [LanguagesEnum.BG as string]: 'Почти сте готови!',
      [LanguagesEnum.EL as string]: 'Σχεδόν τελειώσατε!',
      [LanguagesEnum.ET as string]: 'Oled peaaegu valmis!',
      [LanguagesEnum.HE as string]: 'כמעט סיימת!',
      [LanguagesEnum.HU as string]: 'Majdnem kész!',
      [LanguagesEnum.ID as string]: 'Anda hampir selesai!',
      [LanguagesEnum.JA as string]: 'もうすぐ完了です！',
      [LanguagesEnum.KO as string]: '거의 완료되었습니다!',
      [LanguagesEnum.RU as string]: 'Вы почти закончили!',
      [LanguagesEnum.SK as string]: 'Už ste skoro hotoví!',
      [LanguagesEnum.SL as string]: 'Skoraj končali ste!',
      [LanguagesEnum.TH as string]: 'คุณเกือบเสร็จแล้ว!',
      [LanguagesEnum.HR as string]: 'Skoro ste gotovi!',
      [LanguagesEnum.SR as string]: 'Skoro ste gotovi!',
      [LanguagesEnum.MS as string]: 'Anda hampir selesai!',
      [LanguagesEnum.HI as string]: 'आप लगभग पूरा कर चुके हैं!',
      [LanguagesEnum.SQ as string]: 'Pothuajse mbarove!',
      [LanguagesEnum.BA as string]: 'Skoro ste gotovi!',
      [LanguagesEnum.MK as string]: 'Речиси завршивте!',
      [LanguagesEnum.IS as string]: 'Þú ert næstum búinn!',
      [LanguagesEnum.LB as string]: 'Bal fäerdeg!',
      [LanguagesEnum.BR as string]: 'Você está quase terminando!',
      [LanguagesEnum.UR as string]: 'آپ تقریباً مکمل کر چکے ہیں!',
      [LanguagesEnum.TL as string]: 'Malapit ka nang matapos!',
      [LanguagesEnum.TA as string]: 'நீங்கள் கிட்டத்தட்ட முடித்துவிட்டீர்கள்!',
      [LanguagesEnum.BN as string]: 'আপনি প্রায় শেষ করেছেন!',
      [LanguagesEnum.FA as string]: 'نزدیک است تمام کنید!',
    },
    passedQuiz: {
      [LanguagesEnum.EN as string]: (x: number) =>
        `You passed the quiz. Do you want to submit ${x}% as your final result?`,
      [LanguagesEnum.DK as string]: (x: number) =>
        `Du bestod quizzen. Vil du indsende ${x}% som dit endelige resultat?`,
      [LanguagesEnum.SE as string]: (x: number) =>
        `Du klarade quizzen. Vill du skicka in ${x}% som ditt slutresultat?`,
      [LanguagesEnum.NO as string]: (x: number) =>
        `Du besto quizzen. Vil du sende inn ${x}% som ditt endelige resultat?`,
      [LanguagesEnum.DE as string]: (x: number) =>
        `Sie haben das Quiz bestanden. Möchten Sie ${x}% als Ihr Endergebnis absenden?`,
      [LanguagesEnum.KL as string]: (x: number) =>
        `Quiz-mik aniguisinnaavat. ${x}% Inaarutaasumik inernertut nalunaarutigerusuppiuk?`,
      [LanguagesEnum.AR as string]: (x: number) =>
        `لقد نجحت في الاختبار. هل تريد إرسال نسبة ${x}% كنتيجتك النهائية؟`,
      [LanguagesEnum.CZ as string]: (x: number) =>
        `Úspěšně jste prošli kvízem. Chcete odeslat ${x}% jako svůj konečný výsledek?`,
      [LanguagesEnum.ES as string]: (x: number) =>
        `Has aprobado el cuestionario. ¿Quieres enviar ${x}% como tu resultado final?`,
      [LanguagesEnum.FI as string]: (x: number) =>
        `Läpäisit testin. Haluatko lähettää ${x}% lopulliseksi tulokseksesi?`,
      [LanguagesEnum.FR as string]: (x: number) =>
        `Vous avez réussi le quiz. Voulez-vous envoyer ${x}% comme résultat final ?`,
      [LanguagesEnum.IT as string]: (x: number) =>
        `Hai superato il quiz. Vuoi inviare ${x}% come risultato finale?`,
      [LanguagesEnum.LT as string]: (x: number) =>
        `Jūs išlaikėte testą. Ar norite pateikti ${x}% kaip galutinį rezultatą?`,
      [LanguagesEnum.LV as string]: (x: number) =>
        `Jūs nokārtojāt viktorīnu. Vai vēlaties iesniegt ${x}% kā savu galīgo rezultātu?`,
      [LanguagesEnum.NL as string]: (x: number) =>
        `Je hebt de quiz gehaald. Wil je ${x}% indienen als je eindresultaat?`,
      [LanguagesEnum.PG as string]: (x: number) =>
        `Você passou no quiz. Deseja enviar ${x}% como seu resultado final?`,
      [LanguagesEnum.PL as string]: (x: number) =>
        `Zaliczyłeś quiz. Czy chcesz przesłać ${x}% jako swój wynik końcowy?`,
      [LanguagesEnum.TR as string]: (x: number) =>
        `Testi geçtiniz. ${x}%’i sonucun olarak göndermek ister misiniz?`,
      [LanguagesEnum.VI as string]: (x: number) =>
        `Bạn đã vượt qua bài kiểm tra. Bạn có muốn nộp ${x}% làm kết quả cuối cùng không?`,
      [LanguagesEnum.ZH as string]: (x: number) =>
        `你已通过测验。是否要提交 ${x}% 作为最终结果？`,
      [LanguagesEnum.RO as string]: (x: number) =>
        `Ați promovat testul. Doriți să trimiteți ${x}% ca rezultat final?`,
      [LanguagesEnum.UA as string]: (x: number) =>
        `Ви склали тест. Бажаєте надіслати ${x}% як свій кінцевий результат?`,
      [LanguagesEnum.BG as string]: (x: number) =>
        `Преминахте теста. Искате ли да изпратите ${x}% като краен резултат?`,
      [LanguagesEnum.EL as string]: (x: number) =>
        `Πέρασατε το κουίζ. Θέλετε να υποβάλετε ${x}% ως τελικό σας αποτέλεσμα;`,
      [LanguagesEnum.ET as string]: (x: number) =>
        `Läbisid testi. Kas soovid esitada ${x}% lõpptulemusena?`,
      [LanguagesEnum.HE as string]: (x: number) =>
        `עברת את החידון. האם תרצה לשלוח ${x}% כתוצאה הסופית שלך?`,
      [LanguagesEnum.HU as string]: (x: number) =>
        `Sikeresen teljesítette a kvízt. Szeretné ${x}%-ot beküldeni végeredményként?`,
      [LanguagesEnum.ID as string]: (x: number) =>
        `Anda lulus kuis. Apakah Anda ingin mengirimkan ${x}% sebagai hasil akhir Anda?`,
      [LanguagesEnum.JA as string]: (x: number) =>
        `クイズに合格しました。${x}%を最終結果として送信しますか？`,
      [LanguagesEnum.KO as string]: (x: number) =>
        `퀴즈를 통과했습니다. ${x}%를 최종 결과로 제출하시겠습니까?`,
      [LanguagesEnum.RU as string]: (x: number) =>
        `Вы прошли тест. Хотите отправить ${x}% как окончательный результат?`,
      [LanguagesEnum.SK as string]: (x: number) =>
        `Prešli ste kvíz. Chcete odoslať ${x}% ako svoj konečný výsledok?`,
      [LanguagesEnum.SL as string]: (x: number) =>
        `Opravili ste kviz. Ali želite poslati ${x}% kot svoj končni rezultat?`,
      [LanguagesEnum.TH as string]: (x: number) =>
        `คุณผ่านแบบทดสอบแล้ว คุณต้องการส่ง ${x}% เป็นผลลัพธ์สุดท้ายของคุณหรือไม่?`,
      [LanguagesEnum.HR as string]: (x: number) =>
        `Položili ste kviz. Želite li poslati ${x}% kao konačni rezultat?`,
      [LanguagesEnum.SR as string]: (x: number) =>
        `Položili ste kviz. Želite li predati ${x}% kao konačni rezultat?`,
      [LanguagesEnum.MS as string]: (x: number) =>
        `Anda lulus kuiz. Adakah anda mahu menghantar ${x}% sebagai keputusan akhir anda?`,
      [LanguagesEnum.HI as string]: (x: number) =>
        `आपने क्विज़ पास कर लिया है। क्या आप ${x}% को अपना अंतिम परिणाम सबमिट करना चाहते हैं?`,
      [LanguagesEnum.SQ as string]: (x: number) =>
        `E kaluat testin. Dëshironi të dorëzoni ${x}% si rezultatin përfundimtar?`,
      [LanguagesEnum.BA as string]: (x: number) =>
        `Položili ste kviz. Želite li predati ${x}% kao konačni rezultat?`,
      [LanguagesEnum.MK as string]: (x: number) =>
        `Го положивте квизот. Дали сакате да поднесете ${x}% како конечен резултат?`,
      [LanguagesEnum.IS as string]: (x: number) =>
        `Þú náðir prófinu. Viltu skila ${x}% sem lokaniðurstöðu?`,
      [LanguagesEnum.LB as string]: (x: number) =>
        `Dir hutt de Quiz gepackt. Wëllt Dir ${x}% als Schlussresultat ofginn?`,
      [LanguagesEnum.BR as string]: (x: number) =>
        `Você passou no quiz. Deseja enviar ${x}% como resultado final?`,
      [LanguagesEnum.UR as string]: (x: number) =>
        `آپ کوئز میں کامیاب ہو گئے۔ کیا آپ ${x}% کو حتمی نتیجہ جمع کرنا چاہتے ہیں؟`,
      [LanguagesEnum.TL as string]: (x: number) =>
        `Pumasa ka sa quiz. Gusto mo bang isumite ang ${x}% bilang pinal na resulta?`,
      [LanguagesEnum.TA as string]: (x: number) =>
        `நீங்கள் தேர்ச்சி பெற்றீர்கள். ${x}% ஐ இறுதி முடிவாக சமர்ப்பிக்க விரும்புகிறீர்களா?`,
      [LanguagesEnum.BN as string]: (x: number) =>
        `আপনি কুইজে পাস করেছেন। আপনি কি ${x}% চূড়ান্ত ফলাফল হিসেবে জমা দিতে চান?`,
      [LanguagesEnum.FA as string]: (x: number) =>
        `شما در آزمون قبول شدید. آیا می‌خواهید ${x}٪ را به عنوان نتیجه نهایی ارسال کنید؟`,
    },
    failedQuiz: {
      [LanguagesEnum.EN as string]: (x: number) =>
        `Unfortunately, you didn’t pass the quiz. You need to answer at least ${x}% correct to pass.`,
      [LanguagesEnum.DK as string]: (x: number) =>
        `Desværre bestod du ikke quizzen. Du skal have mindst ${x}% korrekt for at bestå.`,
      [LanguagesEnum.SE as string]: (x: number) =>
        `Tyvärr klarade du inte quizzen. Du behöver minst ${x}% rätt för att klara den.`,
      [LanguagesEnum.NO as string]: (x: number) =>
        `Dessverre besto du ikke quizzen. Du må ha minst ${x}% riktig for å bestå.`,
      [LanguagesEnum.DE as string]: (x: number) =>
        `Leider haben Sie das Quiz nicht bestanden. Sie müssen mindestens ${x}% richtig beantworten, um zu bestehen.`,
      [LanguagesEnum.KL as string]: (x: number) =>
        `Ajoraluartumik quiz-mik aniguinngilatit. ${x}% minnerpaamik eqqortumik naatsorsuutissaavoq.`,
      [LanguagesEnum.AR as string]: (x: number) =>
        `للأسف لم تنجح في الاختبار. تحتاج إلى الإجابة بشكل صحيح على ما لا يقل عن ${x}% للنجاح.`,
      [LanguagesEnum.CZ as string]: (x: number) =>
        `Bohužel jste kvíz nesplnili. Musíte mít alespoň ${x}% správně, abyste uspěli.`,
      [LanguagesEnum.ES as string]: (x: number) =>
        `Lamentablemente, no aprobaste el cuestionario. Necesitas al menos ${x}% de respuestas correctas para aprobar.`,
      [LanguagesEnum.FI as string]: (x: number) =>
        `Valitettavasti et läpäissyt testiä. Tarvitset vähintään ${x}% oikein läpäistäksesi.`,
      [LanguagesEnum.FR as string]: (x: number) =>
        `Malheureusement, vous n’avez pas réussi le quiz. Vous devez avoir au moins ${x}% de bonnes réponses pour réussir.`,
      [LanguagesEnum.IT as string]: (x: number) =>
        `Purtroppo non hai superato il quiz. Devi rispondere correttamente almeno al ${x}% per passare.`,
      [LanguagesEnum.LT as string]: (x: number) =>
        `Deja, neišlaikėte testo. Norint išlaikyti, reikia bent ${x}% teisingų atsakymų.`,
      [LanguagesEnum.LV as string]: (x: number) =>
        `Diemžēl jūs nenokārtojāt viktorīnu. Lai nokārtotu, jābūt vismaz ${x}% pareizu atbilžu.`,
      [LanguagesEnum.NL as string]: (x: number) =>
        `Helaas, je hebt de quiz niet gehaald. Je moet minstens ${x}% goed hebben om te slagen.`,
      [LanguagesEnum.PG as string]: (x: number) =>
        `Infelizmente, você não passou no quiz. É necessário acertar pelo menos ${x}% para passar.`,
      [LanguagesEnum.PL as string]: (x: number) =>
        `Niestety nie zaliczyłeś quizu. Musisz uzyskać co najmniej ${x}% poprawnych odpowiedzi, aby zaliczyć.`,
      [LanguagesEnum.TR as string]: (x: number) =>
        `Maalesef testi geçemediniz. Geçmek için en az ${x}% doğru yapmalısınız.`,
      [LanguagesEnum.VI as string]: (x: number) =>
        `Rất tiếc, bạn chưa vượt qua bài kiểm tra. Bạn cần ít nhất ${x}% trả lời đúng để qua.`,
      [LanguagesEnum.ZH as string]: (x: number) =>
        `很遗憾，你未通过测验。你需要至少答对 ${x}% 才能通过.`,
      [LanguagesEnum.RO as string]: (x: number) =>
        `Din păcate, nu ați promovat testul. Trebuie să răspundeți corect la cel puțin ${x}% pentru a promova.`,
      [LanguagesEnum.UA as string]: (x: number) =>
        `На жаль, ви не склали тест. Потрібно відповісти правильно щонайменше на ${x}%, щоб скласти.`,
      [LanguagesEnum.BG as string]: (x: number) =>
        `За съжаление не преминахте теста. Трябва да отговорите правилно на поне ${x}%, за да преминете.`,
      [LanguagesEnum.EL as string]: (x: number) =>
        `Δυστυχώς, δεν περάσατε το κουίζ. Χρειάζεται να απαντήσετε σωστά τουλάχιστον ${x}% για να περάσετε.`,
      [LanguagesEnum.ET as string]: (x: number) =>
        `Kahjuks sa ei sooritanud testi. Läbimiseks pead vastama vähemalt ${x}% õigesti.`,
      [LanguagesEnum.HE as string]: (x: number) =>
        `למרבה הצער, לא עברת את החידון. עליך לענות נכון לפחות ${x}% כדי לעבור.`,
      [LanguagesEnum.HU as string]: (x: number) =>
        `Sajnos nem sikerült a kvíz. Legalább ${x}%-ot kell helyesen megválaszolnia a sikeres teljesítéshez.`,
      [LanguagesEnum.ID as string]: (x: number) =>
        `Sayangnya, Anda tidak lulus kuis. Anda perlu menjawab setidaknya ${x}% dengan benar untuk lulus.`,
      [LanguagesEnum.JA as string]: (x: number) =>
        `残念ながら、クイズに合格できませんでした。合格するには、少なくとも ${x}% 正しく答える必要があります。`,
      [LanguagesEnum.KO as string]: (x: number) =>
        `안타깝게도 퀴즈를 통과하지 못했습니다. 통과하려면 최소 ${x}%를 정확히 답해야 합니다.`,
      [LanguagesEnum.RU as string]: (x: number) =>
        `К сожалению, вы не прошли тест. Вам нужно ответить правильно как минимум на ${x}%, чтобы пройти.`,
      [LanguagesEnum.SK as string]: (x: number) =>
        `Bohužiaľ ste neprešli kvízom. Aby ste prešli, musíte mať aspoň ${x}% správnych odpovedí.`,
      [LanguagesEnum.SL as string]: (x: number) =>
        `Na žalost niste opravili kviza. Za uspešno opravljanje morate pravilno odgovoriti na vsaj ${x}%.`,
      [LanguagesEnum.TH as string]: (x: number) =>
        `น่าเสียดาย คุณไม่ผ่านแบบทดสอบ คุณต้องตอบถูกอย่างน้อย ${x}% เพื่อให้ผ่าน`,
      [LanguagesEnum.HR as string]: (x: number) =>
        `Nažalost niste položili kviz. Morate imati najmanje ${x}% točnih odgovora za prolaz.`,
      [LanguagesEnum.SR as string]: (x: number) =>
        `Nažalost niste položili kviz. Morate imati najmanje ${x}% tačnih odgovora za prolaz.`,
      [LanguagesEnum.MS as string]: (x: number) =>
        `Malangnya anda tidak lulus kuiz. Anda perlu menjawab sekurang-kurangnya ${x}% dengan betul untuk lulus.`,
      [LanguagesEnum.HI as string]: (x: number) =>
        `दुर्भाग्यवश आप क्विज़ में उत्तीर्ण नहीं हुए। उत्तीर्ण होने के लिए आपको कम से कम ${x}% सही उत्तर देने होंगे।`,
      [LanguagesEnum.SQ as string]: (x: number) =>
        `Fatkeqësisht nuk e kaluat testin. Duhet të përgjigjeni saktë të paktën ${x}%.`,
      [LanguagesEnum.BA as string]: (x: number) =>
        `Nažalost niste položili kviz. Morate imati najmanje ${x}% tačnih odgovora za prolaz.`,
      [LanguagesEnum.MK as string]: (x: number) =>
        `За жал не го положивте квизот. Потребни се најмалку ${x}% точни одговори.`,
      [LanguagesEnum.IS as string]: (x: number) =>
        `Því miður náðir þú ekki prófinu. Þú þarft að svara rétt að minnsta kosti ${x}%.`,
      [LanguagesEnum.LB as string]: (x: number) =>
        `Leider hutt Dir de Quiz net gepackt. Dir braucht mindestens ${x}% richteg.`,
      [LanguagesEnum.BR as string]: (x: number) =>
        `Infelizmente você não passou no quiz. É necessário pelo menos ${x}% de acertos.`,
      [LanguagesEnum.UR as string]: (x: number) =>
        `بدقسمتی سے آپ کوئز میں کامیاب نہیں ہوئے۔ کامیابی کے لیے کم از کم ${x}% درست جوابات درکار ہیں۔`,
      [LanguagesEnum.TL as string]: (x: number) =>
        `Sa kasamaang-palad hindi ka pumasa sa quiz. Kailangan ng hindi bababa sa ${x}% tamang sagot.`,
      [LanguagesEnum.TA as string]: (x: number) =>
        `துரதிருஷ்டவசமாக நீங்கள் தேர்ச்சி பெறவில்லை. குறைந்தது ${x}% சரியான பதில்கள் தேவை.`,
      [LanguagesEnum.BN as string]: (x: number) =>
        `দুঃখিত আপনি কুইজে পাস করেননি। পাস করতে কমপক্ষে ${x}% সঠিক উত্তর প্রয়োজন।`,
      [LanguagesEnum.FA as string]: (x: number) =>
        `متأسفانه در آزمون قبول نشدید. حداقل ${x}٪ پاسخ صحیح لازم است.`,
    },
    thankYouForFeedback: {
      [LanguagesEnum.EN as string]: 'Thank you for your feedback',
      [LanguagesEnum.DK as string]: 'Tak for din feedback',
      [LanguagesEnum.SE as string]: 'Tack för din feedback',
      [LanguagesEnum.NO as string]: 'Takk for tilbakemeldingen',
      [LanguagesEnum.DE as string]: 'Vielen Dank für Ihr Feedback',
      [LanguagesEnum.KL as string]: 'Qujanaq tusarniaanerit pillugit',
      [LanguagesEnum.AR as string]: 'شكرًا على ملاحظاتك',
      [LanguagesEnum.CZ as string]: 'Děkujeme za vaši zpětnou vazbu',
      [LanguagesEnum.ES as string]: 'Gracias por tus comentarios',
      [LanguagesEnum.FI as string]: 'Kiitos palautteestasi',
      [LanguagesEnum.FR as string]: 'Merci pour votre retour',
      [LanguagesEnum.IT as string]: 'Grazie per il tuo feedback',
      [LanguagesEnum.LT as string]: 'Ačiū už jūsų atsiliepimą',
      [LanguagesEnum.LV as string]: 'Paldies par jūsu atsauksmi',
      [LanguagesEnum.NL as string]: 'Bedankt voor je feedback',
      [LanguagesEnum.PG as string]: 'Obrigado pelo seu feedback',
      [LanguagesEnum.PL as string]: 'Dziękujemy za opinię',
      [LanguagesEnum.TR as string]: 'Geri bildiriminiz için teşekkürler',
      [LanguagesEnum.VI as string]: 'Cảm ơn bạn đã phản hồi',
      [LanguagesEnum.ZH as string]: '感谢您的反馈',
      [LanguagesEnum.RO as string]: 'Vă mulțumim pentru feedback',
      [LanguagesEnum.UA as string]: 'Дякуємо за ваш відгук',
      [LanguagesEnum.BG as string]: 'Благодарим за обратната връзка',
      [LanguagesEnum.EL as string]: 'Ευχαριστούμε για τα σχόλιά σας',
      [LanguagesEnum.ET as string]: 'Aitäh tagasiside eest',
      [LanguagesEnum.HE as string]: 'תודה על המשוב שלך',
      [LanguagesEnum.HU as string]: 'Köszönjük a visszajelzést',
      [LanguagesEnum.ID as string]: 'Terima kasih atas masukan Anda',
      [LanguagesEnum.JA as string]: 'フィードバックありがとうございます',
      [LanguagesEnum.KO as string]: '피드백을 주셔서 감사합니다',
      [LanguagesEnum.RU as string]: 'Спасибо за ваш отзыв',
      [LanguagesEnum.SK as string]: 'Ďakujeme za vašu spätnú väzbu',
      [LanguagesEnum.SL as string]: 'Hvala za vašo povratno informacijo',
      [LanguagesEnum.TH as string]: 'ขอบคุณสำหรับความคิดเห็นของคุณ',
      [LanguagesEnum.HR as string]: 'Hvala na vašim povratnim informacijama',
      [LanguagesEnum.SR as string]: 'Hvala na vašim povratnim informacijama',
      [LanguagesEnum.MS as string]: 'Terima kasih atas maklum balas anda',
      [LanguagesEnum.HI as string]: 'आपकी प्रतिक्रिया के लिए धन्यवाद',
      [LanguagesEnum.SQ as string]: 'Faleminderit për komentin tuaj',
      [LanguagesEnum.BA as string]: 'Hvala na vašim povratnim informacijama',
      [LanguagesEnum.MK as string]: 'Ви благодариме за повратните информации',
      [LanguagesEnum.IS as string]: 'Takk fyrir ábendinguna',
      [LanguagesEnum.LB as string]: 'Merci fir däi Feedback',
      [LanguagesEnum.BR as string]: 'Obrigado pelo seu feedback',
      [LanguagesEnum.UR as string]: 'آپ کی رائے کا شکریہ',
      [LanguagesEnum.TL as string]: 'Salamat sa iyong feedback',
      [LanguagesEnum.TA as string]: 'உங்கள் கருத்துக்கு நன்றி',
      [LanguagesEnum.BN as string]: 'আপনার মতামতের জন্য ধন্যবাদ',
      [LanguagesEnum.FA as string]: 'از بازخورد شما سپاسگزاریم',
    },
    tryAgain: {
      [LanguagesEnum.EN as string]: 'Give it another try!',
      [LanguagesEnum.DK as string]: 'Prøv igen!',
      [LanguagesEnum.SE as string]: 'Försök igen!',
      [LanguagesEnum.NO as string]: 'Prøv igjen!',
      [LanguagesEnum.DE as string]: 'Versuchen Sie es noch einmal!',
      [LanguagesEnum.KL as string]: 'Misilikkit alloruk!',
      [LanguagesEnum.AR as string]: 'جرب مرة أخرى!',
      [LanguagesEnum.CZ as string]: 'Zkuste to znovu!',
      [LanguagesEnum.ES as string]: '¡Inténtalo de nuevo!',
      [LanguagesEnum.FI as string]: 'Yritä uudelleen!',
      [LanguagesEnum.FR as string]: 'Réessayez !',
      [LanguagesEnum.IT as string]: 'Riprova!',
      [LanguagesEnum.LT as string]: 'Pabandykite dar kartą!',
      [LanguagesEnum.LV as string]: 'Mēģiniet vēlreiz!',
      [LanguagesEnum.NL as string]: 'Probeer het opnieuw!',
      [LanguagesEnum.PG as string]: 'Tente novamente!',
      [LanguagesEnum.PL as string]: 'Spróbuj ponownie!',
      [LanguagesEnum.TR as string]: 'Tekrar deneyin!',
      [LanguagesEnum.VI as string]: 'Hãy thử lại!',
      [LanguagesEnum.ZH as string]: '再试一次！',
      [LanguagesEnum.RO as string]: 'Încercați din nou!',
      [LanguagesEnum.UA as string]: 'Спробуйте ще раз!',
      [LanguagesEnum.BG as string]: 'Опитайте отново!',
      [LanguagesEnum.EL as string]: 'Δοκιμάστε ξανά!',
      [LanguagesEnum.ET as string]: 'Proovi uuesti!',
      [LanguagesEnum.HE as string]: 'נסה שוב!',
      [LanguagesEnum.HU as string]: 'Próbálja újra!',
      [LanguagesEnum.ID as string]: 'Coba lagi!',
      [LanguagesEnum.JA as string]: 'もう一度お試しください！',
      [LanguagesEnum.KO as string]: '다시 시도해보세요!',
      [LanguagesEnum.RU as string]: 'Попробуйте еще раз!',
      [LanguagesEnum.SK as string]: 'Skúste to znova!',
      [LanguagesEnum.SL as string]: 'Poskusite znova!',
      [LanguagesEnum.TH as string]: 'ลองอีกครั้ง!',
      [LanguagesEnum.HR as string]: 'Pokušajte ponovno!',
      [LanguagesEnum.SR as string]: 'Pokušajte ponovo!',
      [LanguagesEnum.MS as string]: 'Cuba lagi!',
      [LanguagesEnum.HI as string]: 'एक बार फिर प्रयास करें!',
      [LanguagesEnum.SQ as string]: 'Provo sërish!',
      [LanguagesEnum.BA as string]: 'Pokušajte ponovo!',
      [LanguagesEnum.MK as string]: 'Обидете се повторно!',
      [LanguagesEnum.IS as string]: 'Reyndu aftur!',
      [LanguagesEnum.LB as string]: 'Probéier nach eng Kéier!',
      [LanguagesEnum.BR as string]: 'Tente novamente!',
      [LanguagesEnum.UR as string]: 'دوبارہ کوشش کریں!',
      [LanguagesEnum.TL as string]: 'Subukan ulit!',
      [LanguagesEnum.TA as string]: 'மீண்டும் முயற்சிக்கவும்!',
      [LanguagesEnum.BN as string]: 'আবার চেষ্টা করুন!',
      [LanguagesEnum.FA as string]: 'دوباره تلاش کنید!',
    },
  },
  survey: {
    introTitle: {
      [LanguagesEnum.EN as string]:
        'In 2 minutes you can contribute to enhancing our security in the future',
      [LanguagesEnum.DK as string]:
        'På 2 minutter kan du bidrage til at forbedre vores sikkerhed i fremtiden',
      [LanguagesEnum.SE as string]:
        'På 2 minuter kan du bidra till att förbättra vår säkerhet i framtiden',
      [LanguagesEnum.NO as string]:
        'På 2 minutter kan du bidra til å styrke sikkerheten vår i fremtiden',
      [LanguagesEnum.DE as string]:
        'In 2 Minuten können Sie dazu beitragen, unsere Sicherheit in Zukunft zu verbessern',
      [LanguagesEnum.KL as string]:
        'Minutsit marluk atorlugit siunissami isumannaassusitta pitsannguiffiginissaanik pilersitseqataasinnaavutit',
      [LanguagesEnum.AR as string]:
        'في دقيقتين يمكنك المساهمة في تعزيز أمننا في المستقبل',
      [LanguagesEnum.CZ as string]:
        'Za 2 minuty můžete přispět ke zlepšení naší bezpečnosti v budoucnu',
      [LanguagesEnum.ES as string]:
        'En 2 minutos puedes contribuir a mejorar nuestra seguridad en el futuro',
      [LanguagesEnum.FI as string]:
        'Kahdessa minuutissa voit auttaa parantamaan turvallisuuttamme tulevaisuudessa',
      [LanguagesEnum.FR as string]:
        'En 2 minutes, vous pouvez contribuer à renforcer notre sécurité à l’avenir',
      [LanguagesEnum.IT as string]:
        'In 2 minuti puoi contribuire a migliorare la nostra sicurezza in futuro',
      [LanguagesEnum.LT as string]:
        'Per 2 minutes galite prisidėti prie mūsų saugumo stiprinimo ateityje',
      [LanguagesEnum.LV as string]:
        '2 minūtēs jūs varat palīdzēt uzlabot mūsu drošību nākotnē',
      [LanguagesEnum.NL as string]:
        'In 2 minuten kunt u bijdragen aan het verbeteren van onze veiligheid in de toekomst',
      [LanguagesEnum.PG as string]:
        'Em 2 minutos, você pode contribuir para melhorar a nossa segurança no futuro',
      [LanguagesEnum.PL as string]:
        'W 2 minuty możesz przyczynić się do poprawy naszego bezpieczeństwa w przyszłości',
      [LanguagesEnum.TR as string]:
        '2 dakikada gelecekteki güvenliğimizi artırmaya katkıda bulunabilirsiniz',
      [LanguagesEnum.VI as string]:
        'Chỉ trong 2 phút, bạn có thể góp phần nâng cao an ninh của chúng ta trong tương lai',
      [LanguagesEnum.ZH as string]:
        '只需 2 分钟，您就能为提升我们未来的安全贡献一份力量',
      [LanguagesEnum.RO as string]:
        'În doar 2 minute poți contribui la îmbunătățirea securității noastre în viitor',
      [LanguagesEnum.UA as string]:
        'За 2 хвилини ви можете допомогти підвищити нашу безпеку в майбутньому',
    },
    introDescription: {
      [LanguagesEnum.EN as string]:
        'The survey is <b>anonymous</b>, so you can respond openly and honestly. If you are unsure about a question, please choose the answer that best matches your experience.',
      [LanguagesEnum.DK as string]:
        'Spørgeskemaet er <b>anonymt</b>, så du kan svare åbent og ærligt. Hvis du er usikker på et spørgsmål, bedes du vælge det svar, der bedst passer til din oplevelse.',
      [LanguagesEnum.SE as string]:
        'Undersökningen är <b>anonym</b>, så du kan svara öppet och ärligt. Om du är osäker på en fråga, välj det svar som bäst matchar din upplevelse.',
      [LanguagesEnum.NO as string]:
        'Undersøkelsen er <b>anonym</b>, så du kan svare åpent og ærlig. Hvis du er usikker på et spørsmål, velg svaret som best passer din opplevelse.',
      [LanguagesEnum.DE as string]:
        'Die Umfrage ist <b>anonym</b>, sodass Sie offen und ehrlich antworten können. Wenn Sie sich bei einer Frage unsicher sind, wählen Sie bitte die Antwort, die am besten zu Ihrer Erfahrung passt.',
      [LanguagesEnum.KL as string]:
        'Misissuineq <b>ataatsimoorusumik</b> pisoqarpoq, taamaammat akissuteqarsinnaavutit ammasuutigalugu qularnaarnerullu. Apeqqumik nalornilersimassaguit akissut pisinnaatitaanit pisinnarissamut oqqumanerpaamik toqqaaguk.',
      [LanguagesEnum.AR as string]:
        'الاستبيان <b>مجهول الهوية</b>، لذا يمكنك الإجابة بصراحة وأمانة. إذا لم تكن متأكدًا من سؤال ما، يرجى اختيار الإجابة التي تتوافق بشكل أفضل مع تجربتك.',
      [LanguagesEnum.CZ as string]:
        'Průzkum je <b>anonymní</b>, takže můžete odpovídat otevřeně a upřímně. Pokud si nejste jisti odpovědí na otázku, vyberte prosím odpověď, která nejlépe odpovídá vaší zkušenosti.',
      [LanguagesEnum.ES as string]:
        'La encuesta es <b>anónima</b>, por lo que puedes responder abierta y honestamente. Si no estás seguro de una pregunta, elige la respuesta que mejor se ajuste a tu experiencia.',
      [LanguagesEnum.FI as string]:
        'Kysely on <b>anonyymi</b>, joten voit vastata avoimesti ja rehellisesti. Jos olet epävarma kysymyksestä, valitse vastaus, joka parhaiten vastaa kokemustasi.',
      [LanguagesEnum.FR as string]:
        'Le questionnaire est <b>anonyme</b>, vous pouvez donc répondre ouvertement et honnêtement. En cas de doute sur une question, veuillez choisir la réponse qui correspond le mieux à votre expérience.',
      [LanguagesEnum.IT as string]:
        'Il sondaggio è <b>anonimo</b>, quindi puoi rispondere apertamente e onestamente. Se non sei sicuro di una domanda, scegli la risposta che meglio corrisponde alla tua esperienza.',
      [LanguagesEnum.LT as string]:
        'Apklausa yra <b>anoniminė</b>, todėl galite atsakyti atvirai ir sąžiningai. Jei nesate tikri dėl klausimo, pasirinkite atsakymą, kuris geriausiai atitinka jūsų patirtį.',
      [LanguagesEnum.LV as string]:
        'Aptauja ir <b>anonīma</b>, tāpēc varat atbildēt atklāti un godīgi. Ja neesat pārliecināts par kādu jautājumu, lūdzu, izvēlieties atbildi, kas vislabāk atbilst jūsu pieredzei.',
      [LanguagesEnum.NL as string]:
        'De enquête is <b>anoniem</b>, zodat u open en eerlijk kunt antwoorden. Als u twijfelt over een vraag, kies dan het antwoord dat het beste bij uw ervaring past.',
      [LanguagesEnum.PG as string]:
        'O questionário é <b>anónimo</b>, por isso pode responder aberta e honestamente. Se não tiver a certeza sobre uma pergunta, escolha a resposta que melhor corresponde à sua experiência.',
      [LanguagesEnum.PL as string]:
        'Ankieta jest <b>anonimowa</b>, więc możesz odpowiadać otwarcie i szczerze. Jeśli nie jesteś pewien odpowiedzi na pytanie, wybierz odpowiedź, która najlepiej odpowiada Twojemu doświadczeniu.',
      [LanguagesEnum.TR as string]:
        'Anket <b>anonimdir</b>, bu nedenle açık ve dürüst bir şekilde yanıt verebilirsiniz. Bir soru hakkında emin değilseniz, lütfen deneyiminize en uygun yanıtı seçin.',
      [LanguagesEnum.VI as string]:
        'Khảo sát này là <b>ẩn danh</b>, vì vậy bạn có thể trả lời một cách cởi mở và trung thực. Nếu bạn không chắc chắn về một câu hỏi, hãy chọn câu trả lời phù hợp nhất với trải nghiệm của bạn.',
      [LanguagesEnum.ZH as string]:
        '本调查是<b>匿名</b>的，因此您可以坦诚地回答。如果您对某个问题不确定，请选择最符合您经验的答案。',
      [LanguagesEnum.RO as string]:
        'Chestionarul este <b>anonim</b>, așa că puteți răspunde deschis și sincer. Dacă nu sunteți sigur de o întrebare, vă rugăm să alegeți răspunsul care se potrivește cel mai bine cu experiența dumneavoastră.',
      [LanguagesEnum.UA as string]:
        'Опитування є <b>анонімним</b>, тому ви можете відповідати відкрито та чесно. Якщо ви не впевнені у відповіді на запитання, виберіть варіант, який найкраще відповідає вашому досвіду.',
    },
    startNow: {
      [LanguagesEnum.EN as string]: 'Start Survey',
      [LanguagesEnum.DK as string]: 'Start spørgeskema',
      [LanguagesEnum.SE as string]: 'Starta undersökning',
      [LanguagesEnum.NO as string]: 'Start undersøkelse',
      [LanguagesEnum.DE as string]: 'Umfrage starten',
      [LanguagesEnum.KL as string]: 'Misissuineq aallartiguk',
      [LanguagesEnum.AR as string]: 'بدء الاستبيان',
      [LanguagesEnum.CZ as string]: 'Zahájit průzkum',
      [LanguagesEnum.ES as string]: 'Iniciar encuesta',
      [LanguagesEnum.FI as string]: 'Aloita kysely',
      [LanguagesEnum.FR as string]: 'Démarrer le questionnaire',
      [LanguagesEnum.IT as string]: 'Inizia il sondaggio',
      [LanguagesEnum.LT as string]: 'Pradėti apklausą',
      [LanguagesEnum.LV as string]: 'Sākt aptauju',
      [LanguagesEnum.NL as string]: 'Enquête starten',
      [LanguagesEnum.PG as string]: 'Iniciar questionário',
      [LanguagesEnum.PL as string]: 'Rozpocznij ankietę',
      [LanguagesEnum.TR as string]: 'Anketi başlat',
      [LanguagesEnum.VI as string]: 'Bắt đầu khảo sát',
      [LanguagesEnum.ZH as string]: '开始调查',
      [LanguagesEnum.RO as string]: 'Începeți chestionarul',
      [LanguagesEnum.UA as string]: 'Розпочати опитування',
    },
    completedTitle: {
      [LanguagesEnum.EN as string]: 'Your response has been submitted',
      [LanguagesEnum.DK as string]: 'Dit svar er blevet indsendt',
      [LanguagesEnum.SE as string]: 'Ditt svar har skickats in',
      [LanguagesEnum.NO as string]: 'Svaret ditt er sendt inn',
      [LanguagesEnum.DE as string]: 'Ihre Antwort wurde übermittelt',
      [LanguagesEnum.KL as string]: 'Akissutit nassiunneqarput',
      [LanguagesEnum.AR as string]: 'تم إرسال إجابتك',
      [LanguagesEnum.CZ as string]: 'Vaše odpověď byla odeslána',
      [LanguagesEnum.ES as string]: 'Tu respuesta ha sido enviada',
      [LanguagesEnum.FI as string]: 'Vastauksesi on lähetetty',
      [LanguagesEnum.FR as string]: 'Votre réponse a été soumise',
      [LanguagesEnum.IT as string]: 'La tua risposta è stata inviata',
      [LanguagesEnum.LT as string]: 'Jūsų atsakymas pateiktas',
      [LanguagesEnum.LV as string]: 'Jūsu atbilde ir iesniegta',
      [LanguagesEnum.NL as string]: 'Uw antwoord is ingediend',
      [LanguagesEnum.PG as string]: 'A sua resposta foi enviada',
      [LanguagesEnum.PL as string]: 'Twoja odpowiedź została przesłana',
      [LanguagesEnum.TR as string]: 'Yanıtınız gönderildi',
      [LanguagesEnum.VI as string]: 'Câu trả lời của bạn đã được gửi',
      [LanguagesEnum.ZH as string]: '您的回复已提交',
      [LanguagesEnum.RO as string]: 'Răspunsul dvs. a fost trimis',
      [LanguagesEnum.UA as string]: 'Вашу відповідь надіслано',
    },
    completedDescription: {
      [LanguagesEnum.EN as string]: 'Thank you for your time and effort',
      [LanguagesEnum.DK as string]: 'Tak for din tid og indsats',
      [LanguagesEnum.SE as string]: 'Tack för din tid och insats',
      [LanguagesEnum.NO as string]: 'Takk for din tid og innsats',
      [LanguagesEnum.DE as string]: 'Vielen Dank für Ihre Zeit und Mühe',
      [LanguagesEnum.KL as string]:
        'Qujanaq pisinnarissat akuersissimanerat pillugit',
      [LanguagesEnum.AR as string]: 'شكرًا لوقتك وجهدك',
      [LanguagesEnum.CZ as string]: 'Děkujeme za váš čas a úsilí',
      [LanguagesEnum.ES as string]: 'Gracias por tu tiempo y esfuerzo',
      [LanguagesEnum.FI as string]: 'Kiitos ajastasi ja vaivannäöstäsi',
      [LanguagesEnum.FR as string]: 'Merci pour votre temps et vos efforts',
      [LanguagesEnum.IT as string]: 'Grazie per il tuo tempo e il tuo impegno',
      [LanguagesEnum.LT as string]: 'Dėkojame už jūsų laiką ir pastangas',
      [LanguagesEnum.LV as string]: 'Paldies par jūsu laiku un pūlēm',
      [LanguagesEnum.NL as string]: 'Bedankt voor uw tijd en moeite',
      [LanguagesEnum.PG as string]: 'Obrigado pelo seu tempo e esforço',
      [LanguagesEnum.PL as string]: 'Dziękujemy za poświęcony czas i wysiłek',
      [LanguagesEnum.TR as string]:
        'Zaman ayırdığınız ve gösterdiğiniz çaba için teşekkürler',
      [LanguagesEnum.VI as string]: 'Cảm ơn bạn đã dành thời gian và công sức',
      [LanguagesEnum.ZH as string]: '感谢您的时间和努力',
      [LanguagesEnum.RO as string]:
        'Vă mulțumim pentru timpul și efortul dumneavoastră',
      [LanguagesEnum.UA as string]: 'Дякуємо за ваш час та зусилля',
    },
    completedAlt: {
      [LanguagesEnum.EN as string]: 'Survey completed',
      [LanguagesEnum.DK as string]: 'Spørgeskema gennemført',
      [LanguagesEnum.SE as string]: 'Undersökning slutförd',
      [LanguagesEnum.NO as string]: 'Undersøkelse fullført',
      [LanguagesEnum.DE as string]: 'Umfrage abgeschlossen',
      [LanguagesEnum.KL as string]: 'Misissuineq naammassisimavoq',
      [LanguagesEnum.AR as string]: 'تم إكمال الاستبيان',
      [LanguagesEnum.CZ as string]: 'Průzkum dokončen',
      [LanguagesEnum.ES as string]: 'Encuesta completada',
      [LanguagesEnum.FI as string]: 'Kysely suoritettu',
      [LanguagesEnum.FR as string]: 'Questionnaire terminé',
      [LanguagesEnum.IT as string]: 'Sondaggio completato',
      [LanguagesEnum.LT as string]: 'Apklausa baigta',
      [LanguagesEnum.LV as string]: 'Aptauja pabeigta',
      [LanguagesEnum.NL as string]: 'Enquête voltooid',
      [LanguagesEnum.PG as string]: 'Questionário concluído',
      [LanguagesEnum.PL as string]: 'Ankieta ukończona',
      [LanguagesEnum.TR as string]: 'Anket tamamlandı',
      [LanguagesEnum.VI as string]: 'Khảo sát đã hoàn thành',
      [LanguagesEnum.ZH as string]: '调查已完成',
      [LanguagesEnum.RO as string]: 'Chestionar finalizat',
      [LanguagesEnum.UA as string]: 'Опитування завершено',
    },
    alreadySubmittedTitle: {
      [LanguagesEnum.EN as string]: 'An answer has already been submitted',
      [LanguagesEnum.DK as string]: 'Et svar er allerede blevet indsendt',
      [LanguagesEnum.SE as string]: 'Ett svar har redan skickats in',
      [LanguagesEnum.NO as string]: 'Et svar er allerede sendt inn',
      [LanguagesEnum.DE as string]: 'Eine Antwort wurde bereits übermittelt',
      [LanguagesEnum.KL as string]: 'Akissut qaammat nassiunneqarsimavoq',
      [LanguagesEnum.AR as string]: 'تم إرسال إجابة بالفعل',
      [LanguagesEnum.CZ as string]: 'Odpověď již byla odeslána',
      [LanguagesEnum.ES as string]: 'Ya se ha enviado una respuesta',
      [LanguagesEnum.FI as string]: 'Vastaus on jo lähetetty',
      [LanguagesEnum.FR as string]: 'Une réponse a déjà été soumise',
      [LanguagesEnum.IT as string]: 'Una risposta è già stata inviata',
      [LanguagesEnum.LT as string]: 'Atsakymas jau pateiktas',
      [LanguagesEnum.LV as string]: 'Atbilde jau ir iesniegta',
      [LanguagesEnum.NL as string]: 'Er is al een antwoord ingediend',
      [LanguagesEnum.PG as string]: 'Uma resposta já foi enviada',
      [LanguagesEnum.PL as string]: 'Odpowiedź została już przesłana',
      [LanguagesEnum.TR as string]: 'Bir yanıt zaten gönderildi',
      [LanguagesEnum.VI as string]: 'Câu trả lời đã được gửi trước đó',
      [LanguagesEnum.ZH as string]: '已提交过回复',
      [LanguagesEnum.RO as string]: 'Un răspuns a fost deja trimis',
      [LanguagesEnum.UA as string]: 'Відповідь вже надіслано',
    },
    alreadySubmittedDescription: {
      [LanguagesEnum.EN as string]: 'Thank you for participating',
      [LanguagesEnum.DK as string]: 'Tak fordi du deltog',
      [LanguagesEnum.SE as string]: 'Tack för ditt deltagande',
      [LanguagesEnum.NO as string]: 'Takk for at du deltok',
      [LanguagesEnum.DE as string]: 'Vielen Dank für Ihre Teilnahme',
      [LanguagesEnum.KL as string]: 'Qujanaq peqataanerat pillugu',
      [LanguagesEnum.AR as string]: 'شكرًا على مشاركتك',
      [LanguagesEnum.CZ as string]: 'Děkujeme za vaši účast',
      [LanguagesEnum.ES as string]: 'Gracias por participar',
      [LanguagesEnum.FI as string]: 'Kiitos osallistumisestasi',
      [LanguagesEnum.FR as string]: 'Merci pour votre participation',
      [LanguagesEnum.IT as string]: 'Grazie per aver partecipato',
      [LanguagesEnum.LT as string]: 'Dėkojame už dalyvavimą',
      [LanguagesEnum.LV as string]: 'Paldies par dalību',
      [LanguagesEnum.NL as string]: 'Bedankt voor uw deelname',
      [LanguagesEnum.PG as string]: 'Obrigado por participar',
      [LanguagesEnum.PL as string]: 'Dziękujemy za udział',
      [LanguagesEnum.TR as string]: 'Katılımınız için teşekkürler',
      [LanguagesEnum.VI as string]: 'Cảm ơn bạn đã tham gia',
      [LanguagesEnum.ZH as string]: '感谢您的参与',
      [LanguagesEnum.RO as string]: 'Vă mulțumim pentru participare',
      [LanguagesEnum.UA as string]: 'Дякуємо за участь',
    },
    errorTitle: {
      [LanguagesEnum.EN as string]: 'Error',
      [LanguagesEnum.DK as string]: 'Fejl',
      [LanguagesEnum.SE as string]: 'Fel',
      [LanguagesEnum.NO as string]: 'Feil',
      [LanguagesEnum.DE as string]: 'Fehler',
      [LanguagesEnum.KL as string]: 'Kukkuneq',
      [LanguagesEnum.AR as string]: 'خطأ',
      [LanguagesEnum.CZ as string]: 'Chyba',
      [LanguagesEnum.ES as string]: 'Error',
      [LanguagesEnum.FI as string]: 'Virhe',
      [LanguagesEnum.FR as string]: 'Erreur',
      [LanguagesEnum.IT as string]: 'Errore',
      [LanguagesEnum.LT as string]: 'Klaida',
      [LanguagesEnum.LV as string]: 'Kļūda',
      [LanguagesEnum.NL as string]: 'Fout',
      [LanguagesEnum.PG as string]: 'Erro',
      [LanguagesEnum.PL as string]: 'Błąd',
      [LanguagesEnum.TR as string]: 'Hata',
      [LanguagesEnum.VI as string]: 'Lỗi',
      [LanguagesEnum.ZH as string]: '错误',
      [LanguagesEnum.RO as string]: 'Eroare',
      [LanguagesEnum.UA as string]: 'Помилка',
    },
    errorAnswerRequired: {
      [LanguagesEnum.EN as string]:
        'Please answer the question before proceeding.',
      [LanguagesEnum.DK as string]:
        'Besvar venligst spørgsmålet, før du fortsætter.',
      [LanguagesEnum.SE as string]:
        'Vänligen besvara frågan innan du fortsätter.',
      [LanguagesEnum.NO as string]:
        'Vennligst svar på spørsmålet før du fortsetter.',
      [LanguagesEnum.DE as string]:
        'Bitte beantworten Sie die Frage, bevor Sie fortfahren.',
      [LanguagesEnum.KL as string]:
        'Apeqqumik akissuteqarit siunermu ingerlanissannit.',
      [LanguagesEnum.AR as string]: 'يرجى الإجابة على السؤال قبل المتابعة.',
      [LanguagesEnum.CZ as string]:
        'Před pokračováním prosím odpovězte na otázku.',
      [LanguagesEnum.ES as string]:
        'Por favor, responde la pregunta antes de continuar.',
      [LanguagesEnum.FI as string]: 'Vastaa kysymykseen ennen kuin jatkat.',
      [LanguagesEnum.FR as string]:
        'Veuillez répondre à la question avant de continuer.',
      [LanguagesEnum.IT as string]:
        'Si prega di rispondere alla domanda prima di procedere.',
      [LanguagesEnum.LT as string]:
        'Prašome atsakyti į klausimą prieš tęsiant.',
      [LanguagesEnum.LV as string]:
        'Lūdzu, atbildiet uz jautājumu pirms turpināšanas.',
      [LanguagesEnum.NL as string]: 'Beantwoord de vraag voordat u verdergaat.',
      [LanguagesEnum.PG as string]:
        'Por favor, responda à pergunta antes de prosseguir.',
      [LanguagesEnum.PL as string]:
        'Proszę odpowiedzieć na pytanie przed kontynuowaniem.',
      [LanguagesEnum.TR as string]:
        'Devam etmeden önce lütfen soruyu cevaplayın.',
      [LanguagesEnum.VI as string]:
        'Vui lòng trả lời câu hỏi trước khi tiếp tục.',
      [LanguagesEnum.ZH as string]: '请先回答问题再继续。',
      [LanguagesEnum.RO as string]:
        'Vă rugăm să răspundeți la întrebare înainte de a continua.',
      [LanguagesEnum.UA as string]:
        'Будь ласка, дайте відповідь на запитання перед продовженням.',
    },
  },
};

export default hardcodedTranslations;
